/**
 * custom-price-form.js
 * =====================
 * Section DIŞINDA yaşayan global script.
 * Shopify section rendering (idiomorph morph/replace) bu dosyayı ETKİLEMEZ.
 * Tüm event'ler document seviyesinde delegation ile dinlenir.
 * Form HTML'i section içinde kalır, bu JS onu dışarıdan yönetir.
 *
 * DÜZELTMELER (v2):
 * - addToCartRetry: recursive promise zinciri düzeltildi, parse hatası yakalandı
 * - Varyant oluşturma sonrası bekleme süresi 2000ms → 3500ms (Shopify sync süresi)
 * - Retry sayısı 4 → 6, aralık 1000ms → 1500ms
 * - setBtnsLoading: tüm hata dallarında güvenli şekilde false çağrılıyor
 * - handleCartClick: fetch zinciri tek catch bloğuyla sadeleştirildi
 * - getCalcData: state yoksa erken çıkış güvencesi eklendi
 *
 * DÜZELTMELER (v3):
 * - injectCartStyles: duplicate tanım kaldırıldı, tek fonksiyon olarak birleştirildi
 * - Sepet drawer +/- butonları ve miktar input'u yeniden tasarlandı
 * - Sayı (quantity) büyük ve net görünür hale getirildi
 * - Kaldır linki hover'da kırmızıya döner (UX iyileştirmesi)
 *
 * DÜZELTMELER (v4):
 * - handleCartClick: sepet drawer güncelleme stratejisi tamamen yeniden yazıldı
 *   Problem: cart/add.js'e istek atılıyor ama tema "ürün eklendi" eventini görmüyor.
 *   Çözüm: sections API ile cart HTML'i çekip outerHTML ile güncelleme ÖNCE yapılır,
 *           ardından drawer açılır. Ayrıca tema'nın kendi event sistemine de sinyal
 *           gönderilir (cart:refresh, theme:cart:open vb.) fallback olarak.
 *   - updateCartAndOpenDrawer: ayrı fonksiyon olarak çıkarıldı, 3 katmanlı strateji
 *   - refreshCartSection: sections API güncelleme + custom element reconnect
 *   - notifyThemeCart: tema'ya cart refresh eventi gönder
 *
 * DÜZELTMELER (v6):
 * - FIX 3 — Mobilde 0.00TL / çanta ikonu sepete düşüyordu:
 *   Problem: Storefront sync gecikince ilk cart/add.js bazen 0 fiyat dönebiliyordu.
 *   Çözüm: Daha uzun sync bekleme + cart/add.js retry + fiyat 0 dönerse
 *   cart/change.js ile satırı silip kısa gecikmeyle yeniden ekleme akışı.
 *
 * DÜZELTMELER (v5):
 * - FIX 1 — Kesim şekli sepete yanlış gidiyordu:
 *   selectShape() içine calculate() çağrısı eklendi.
 *   Önceki davranış: şekil seçilince sadece UI güncellenir, calcData.kesim eski kalırdı.
 *   Yeni davranış: şekil seçilince hesaplama yeniden yapılır, calcData.kesim anında güncellenir.
 *
 * - FIX 2 — Drawer dışına tıklayınca kapanmıyordu:
 *   setupOverlayClick fonksiyonundaki _cpfClickBound single-bind guard kaldırıldı.
 *   Önceki davranış: overlay click listener sadece ilk drawer açılışında bağlanırdı.
 *   Yeni davranış: openCartDrawer() çağrısından sonra her seferinde overlay yeniden bulunup
 *   click listener ekleniyor. Ayrıca pointer-events her açılışta güvenli şekilde ayarlanıyor.
 *
 * DÜZELTMELER (v7):
 * - FIX 4 — "Kaldır" butonuna basınca drawer kapanıyordu, ürün silinmiyordu:
 *   Problem: refreshCartSection → innerHTML güncellemesi sonrası Seventh'in
 *   "Kaldır" linklerine bağlı click listener'lar kopuyor. Tıklayınca
 *   overlay click handler devreye giriyor → drawer kapanıyor.
 *   Çözüm: delegateCartRemove() ile document seviyesinde delegation.
 *   CPF tarafı kaldır tıklarını yakalar, cart/change.js ile siler,
 *   section HTML'ini günceller.
 *
 * DÜZELTMELER (v8):
 * - FIX 5 — Sepet boşken drawer açılmıyordu (race condition):
 *   Problem: _cartItemCountBefore fetch'i promise zincirine dahil değildi.
 *   cart.js fetch beklenmiyor, varyant fetch hemen başlıyor → _cartItemCountBefore
 *   her zaman -1 kalıyor → updateCartAndOpenDrawer içinde reload hiç tetiklenmiyor
 *   → boş sepet drawer'ı açılamıyor.
 *   Çözüm: cart.js fetch zincire dahil edildi, varyant fetch onun .then()'i içinde başlıyor.
 */
(function () {
  'use strict';

  /* Tek seferlik guard — script birden fazla kez yüklenirse sadece ilki çalışır */
  if (window.__cpfGlobal) return;
  window.__cpfGlobal = true;

  /* ============================================
    ERKEN FOUC ÇÖZÜMÜ
    Custom formu OLMAYAN ürünlerde #customPriceForm yoktur.
    Bu durumda initCPF() çalışmaz → cpf-variants-ready hiç eklenmez
    → varyantlar opacity:0'da takılır. Hemen class ekleyerek çöz.
    ============================================ */
  if (!document.getElementById('customPriceForm')) {
    document.body.classList.add('cpf-variants-ready');
  }

  /* ============================================
    YARDIMCI FONKSİYONLAR
    ============================================ */
  var BACKEND = 'https://srv.noxhali.com/api/create-draft-order';
  var CART_VARIANT_URL = 'https://srv.noxhali.com/api/create-cart-variant';
  var SHOPIFY_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var VARIANT_SYNC_WAIT_MS = 4500;
  var ADD_TO_CART_RETRIES = 3;
  var ADD_TO_CART_RETRY_DELAY_MS = 1500;
  var _cartFlowBusy = false;
  var _cartItemCountBefore = -1;
  var _overlayScrollY = 0;
  var _drawerOpenGrace = 0;        /* drawer açılırken watchdog'u baskıla */
  var _cachedCartSectionId = null; /* bulunan section ID cache */
  var _cpfOzelSuspended = false;   /* drawer açıkken cpf-mode-ozel geçici kaldırıldı mı */
  var _lastCartAddSections = null;  /* cart/add.js response'undaki sections HTML */

  /* Cart section ID'yi başlat. sidebar varsa hemen bul,
     yoksa MutationObserver ile bekle. */
  (function _initCartSectionId() {
    function _find() {
      var sb = document.getElementById('site-cart-sidebar');
      if (!sb) return false;
      var wr = sb.closest('[id^="shopify-section-"]');
      if (wr) { _cachedCartSectionId = wr.id.replace('shopify-section-', ''); return true; }
      var all = document.querySelectorAll('[id^="shopify-section-"]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].querySelector('#site-cart-sidebar')) {
          _cachedCartSectionId = all[i].id.replace('shopify-section-', '');
          return true;
        }
      }
      return false;
    }
    if (_find()) return;
    var _obs = new MutationObserver(function () {
      if (_find()) _obs.disconnect();
    });
    _obs.observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* Para birimi formatlayıcı — Türk Lirası */
  function fmt(n) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(n) + 'TL';
  }

  /* getElementById kısaltması */
  function $(id) { return document.getElementById(id); }

  /* Debug — sadece console, görünür banner kapalı */
  function _dbg(msg) {
    console.log('[CPF] ' + msg);
  }

  /* ============================================
    SAYFA YÜKLENİNCE CUSTOM VARIANT URL TEMİZLE
    ============================================ */
  (function cleanCustomVariantUrl() {
    var url = new URL(window.location.href);
    var vid = url.searchParams.get('variant');
    if (!vid) return;

    var productJson = document.querySelector(
      '[data-product-json], script[data-product-json], [type="application/json"][data-product-json]'
    );
    if (productJson) {
      try {
        var pData = JSON.parse(productJson.textContent);
        var vObj = (pData.variants || []).find(function (v) {
          return String(v.id) === String(vid);
        });
        if (vObj && vObj.title && (vObj.title.indexOf('Özel Ölçü ') === 0 || vObj.title.indexOf('Custom ') === 0)) {
          _dbg('Custom variant URL tespit edildi, temizleniyor...');
          url.searchParams.delete('variant');
          window.location.replace(url.toString());
          return;
        }
      } catch (e) { }
    }
  })();

  /* ============================================
    DOM REFERANS TAKİBİ
    ============================================ */
  var _lastFormRef = null;
  var _lastVid = null;
  var _initBusy = false;

  /* ============================================
    ANA INIT — Her section render sonrası çağrılır
    ============================================ */
  function initCPF(force) {
    if (_initBusy) return;

    var W = $('customPriceForm');
    if (!W) { _dbg('init: form DOM\'da YOK!'); return; }

    if (window.__cpfState) {
      var activeTab = document.querySelector('#customPriceForm .cpf-tab--active');
      if (activeTab && activeTab.getAttribute('data-tab') === 'standart' && !force) {
        return;
      }
    }

    try {
      var urlVid = new URLSearchParams(location.search).get('variant');
      if (urlVid) W.setAttribute('data-variant-id', urlVid);
    } catch (e) { }

    var currentVid = W.getAttribute('data-variant-id') || '';

    if (!force && W === _lastFormRef && currentVid === _lastVid) return;

    _initBusy = true;
    _lastFormRef = W;
    _lastVid = currentVid;

    W.style.display = '';
    W.style.visibility = 'visible';
    W.style.opacity = '1';

    _dbg('init vid=' + currentVid + (force ? ' FORCED' : ''));

    var m2Price = parseFloat(W.dataset.m2Price) || 0;
    var m2Compare = parseFloat(W.dataset.m2Compare) || 0;
    var maxBoy = parseInt(W.dataset.maxBoy) || 99999;
    var variantId = W.dataset.variantId;
    var productTitle = W.dataset.productTitle;
    var productId = W.dataset.productId;
    var shopDomain = W.dataset.shopDomain;
    var productImage = W.dataset.productImage || '';
    if (productImage && productImage.indexOf('//') === 0) productImage = 'https:' + productImage;
    var sacakAktif = W.dataset.sacakAktif === 'true';
    var kesimAktif = W.dataset.kesimAktif === 'true';
    var postAktif = W.dataset.postKesimAktif === 'true';
    var minEn = parseInt(W.dataset.minEn) || 0;
    var minBoy = parseInt(W.dataset.minBoy) || 0;

    var ruloEnleri = [];
    (W.dataset.ruloEnleri || '').split(',').forEach(function (s) {
      var n = parseInt(s.trim());
      if (n > 0) ruloEnleri.push(n);
    });
    ruloEnleri.sort(function (a, b) { return a - b; });

    var hazirEbatlar = [];
    (W.dataset.hazirEbatlar || '').split(',').forEach(function (s) {
      var p = s.trim().split('x');
      if (p.length === 2) {
        hazirEbatlar.push({ en: parseInt(p[0]), boy: parseInt(p[1]) });
      }
    });

    var maxRuloEn = ruloEnleri.length ? ruloEnleri[ruloEnleri.length - 1] : 99999;
    var absMaxEn = maxRuloEn;
    hazirEbatlar.forEach(function (e) { if (e.en > absMaxEn) absMaxEn = e.en; });
    var absMaxBoy = maxBoy;
    hazirEbatlar.forEach(function (e) { if (e.boy > absMaxBoy) absMaxBoy = e.boy; });

    var kesimSec = $('cpfKesimSection');
    var sacakSec = $('cpfSacakSection');
    var postBtn = $('cpfPostBtn');
    if (kesimAktif && kesimSec) kesimSec.style.display = '';
    if (sacakAktif && sacakSec) sacakSec.style.display = '';
    if (postAktif && kesimAktif && postBtn) postBtn.style.display = '';

    window.__cpfState = {
      m2Price: m2Price,
      m2Compare: m2Compare,
      maxBoy: maxBoy,
      variantId: variantId,
      productTitle: productTitle,
      productId: productId,
      shopDomain: shopDomain,
      productImage: productImage,
      sacakAktif: sacakAktif,
      kesimAktif: kesimAktif,
      postAktif: postAktif,
      ruloEnleri: ruloEnleri,
      hazirEbatlar: hazirEbatlar,
      maxRuloEn: maxRuloEn,
      absMaxEn: absMaxEn,
      absMaxBoy: absMaxBoy,
      minEn: minEn,
      minBoy: minBoy,
      currentShape: (window.__cpfState ? window.__cpfState.currentShape : 'Dikdortgen'),
      calcData: null
    };

    repositionForm();
    hideCustomVariants();

    var prevTab = (window.__cpfState && window.__cpfState.activeTab) ? window.__cpfState.activeTab : 'standart';
    switchTab(prevTab);

    setTimeout(hideCustomVariants, 500);
    setTimeout(hideCustomVariants, 1500);

    setupVarObserver();

    _initBusy = false;
    _dbg('Form hazır ✓ vid=' + (window.__cpfState ? window.__cpfState.variantId : '?'));
  }

  /* ============================================
    RULO EŞLEŞTİRME
    ============================================ */
  function ruloEslestir(en, boy) {
    var s = window.__cpfState;
    if (!s) return null;

    for (var i = 0; i < s.ruloEnleri.length; i++) {
      if (en <= s.ruloEnleri[i]) {
        return { tip: 'rulo', faturaEn: s.ruloEnleri[i], faturaBoy: boy };
      }
    }

    for (var j = 0; j < s.hazirEbatlar.length; j++) {
      var h = s.hazirEbatlar[j];
      if (en <= h.en && boy <= h.boy) {
        return { tip: 'jumbo', faturaEn: h.en, faturaBoy: h.boy };
      }
    }

    return null;
  }

  function smartSwap(en, boy) {
    return { en: en, boy: boy, swapped: false };
  }

  /* ============================================
    ANA HESAPLAMA
    ============================================ */
  function calculate() {
    var s = window.__cpfState;
    if (!s) return;

    var inEn = $('cpf-en');
    var inBoy = $('cpf-boy');
    var enErr = $('cpf-en-error');
    var boyErr = $('cpf-boy-error');
    var swapBar = $('cpfSwapBar');
    var pricing = $('cpfPricing');
    var oldUnit = $('cpfOldUnit');
    var newUnit = $('cpfNewUnit');
    var oldTotal = $('cpfOldTotal');
    var newTotal = $('cpfNewTotal');
    var badge = $('cpfBadge');
    var detail = $('cpfDetail');
    var errEl = $('cpfError');
    var cartBtn = $('cpfCartBtn');
    var orderBtn = $('cpfOrderBtn');
    var toastEl = $('cpfToast');
    if (!inEn || !inBoy) return;

    var rawEn = parseInt(inEn.value) || 0;
    var rawBoy = parseInt(inBoy.value) || 0;

    if (enErr) enErr.textContent = '';
    if (boyErr) boyErr.textContent = '';
    inEn.classList.remove('cpf-input--error');
    inBoy.classList.remove('cpf-input--error');
    if (swapBar) swapBar.style.display = 'none';
    if (errEl) errEl.style.display = 'none';
    if (pricing) pricing.style.display = 'none';
    if (cartBtn) cartBtn.disabled = true;
    if (orderBtn) orderBtn.disabled = true;
    if (toastEl) toastEl.style.display = 'none';

    if (rawEn <= 0 || rawBoy <= 0) { s.calcData = null; return; }

    if (s.minEn > 0 && rawEn < s.minEn) {
      if (enErr) enErr.textContent = 'Minimum en ölçüsü ' + s.minEn + ' cm\'dir.';
      inEn.classList.add('cpf-input--error');
      s.calcData = null; return;
    }

    if (s.minBoy > 0 && rawBoy < s.minBoy) {
      if (boyErr) boyErr.textContent = 'Minimum boy ölçüsü ' + s.minBoy + ' cm\'dir.';
      inBoy.classList.add('cpf-input--error');
      s.calcData = null; return;
    }

    if (rawBoy > s.absMaxBoy) {
      if (boyErr) boyErr.textContent = 'Maksimum boy ölçüsü bu ürün için ' + s.absMaxBoy + ' cm\'dir.';
      inBoy.classList.add('cpf-input--error');
      s.calcData = null; return;
    }

    var sw = smartSwap(rawEn, rawBoy);
    if (sw.swapped) {
      inEn.value = sw.en;
      inBoy.value = sw.boy;
      if (swapBar) swapBar.style.display = '';
      rawEn = sw.en;
      rawBoy = sw.boy;
    }

    if (rawEn > s.absMaxEn) {
      if (enErr) enErr.textContent = 'Maksimum en ölçüsü bu ürün için ' + s.absMaxEn + ' cm\'dir.';
      inEn.classList.add('cpf-input--error');
      s.calcData = null; return;
    }

    var e = ruloEslestir(rawEn, rawBoy);
    if (!e) {
      if (enErr) enErr.textContent = 'Bu ölçüler için uygun ürün bulunamadı.';
      inEn.classList.add('cpf-input--error');
      s.calcData = null; return;
    }

    var faturaAlan = (e.faturaEn / 100) * (e.faturaBoy / 100);
    var yeniFiyat = faturaAlan * s.m2Price;
    var eskiFiyat = s.m2Compare > 0 ? faturaAlan * s.m2Compare : 0;

    updateShapes(rawEn, rawBoy);

    if (pricing) pricing.style.display = '';

    if (s.m2Compare > 0 && s.m2Compare > s.m2Price) {
      if (oldUnit) { oldUnit.textContent = fmt(s.m2Compare) + '/m²'; oldUnit.style.display = ''; }
    } else {
      if (oldUnit) oldUnit.style.display = 'none';
    }
    if (newUnit) newUnit.textContent = fmt(s.m2Price) + '/m²';
    if (newTotal) newTotal.textContent = fmt(yeniFiyat);

    if (eskiFiyat > yeniFiyat) {
      var oldRow = $('cpfOldRow');
      if (oldTotal) oldTotal.textContent = fmt(eskiFiyat);
      var pct = Math.round((eskiFiyat - yeniFiyat) / eskiFiyat * 100);
      if (badge) badge.textContent = '%' + pct + ' İndirim';
      if (oldRow) oldRow.style.display = '';
    } else {
      var oldRow2 = $('cpfOldRow');
      if (oldRow2) oldRow2.style.display = 'none';
    }

    if (detail) { detail.textContent = ''; detail.style.display = 'none'; }

    if (cartBtn) cartBtn.disabled = false;
    if (orderBtn) orderBtn.disabled = false;

    s.calcData = {
      girilenEn: rawEn,
      girilenBoy: rawBoy,
      faturaEn: e.faturaEn,
      faturaBoy: e.faturaBoy,
      tip: e.tip,
      alan: faturaAlan,
      fiyat: yeniFiyat,
      eskiFiyat: eskiFiyat > yeniFiyat ? eskiFiyat : 0,
      sacak: s.sacakAktif ? (getSacak() ? 'Saçaklı' : 'Saçaksız') : '-',
      kesim: s.kesimAktif ? s.currentShape : '-',
      not: ''
    };
  }

  /* ============================================
    KESİM ŞEKLİ
    ============================================ */
  function updateShapes(en, boy) {
    var s = window.__cpfState;
    if (!s || !s.kesimAktif) return;

    var isKare = (en > 0 && boy > 0 && en === boy);

    /* Kare ölçü → sadece Kare ve Yuvarlak göster
       Dikdörtgen ölçü → sadece Dikdörtgen ve Oval göster */
    document.querySelectorAll('#customPriceForm .cpf-shape').forEach(function (btn) {
      var shape = btn.dataset.shape;
      if (shape === 'Post') return; /* Post ayrı mantıkla gösterilir */

      if (isKare) {
        btn.style.display = (shape === 'Kare' || shape === 'Yuvarlak') ? '' : 'none';
      } else {
        btn.style.display = (shape === 'Dikdortgen' || shape === 'Oval') ? '' : 'none';
      }
    });

    /* Otomatik şekil seçimi */
    var autoShape = isKare ? 'Kare' : 'Dikdortgen';

    /* Eğer şu anki seçili şekil gizlendiyse veya ilk kez girildiyse otomatik seç */
    var curBtn = document.querySelector('#customPriceForm .cpf-shape[data-shape="' + s.currentShape + '"]');
    if (!curBtn || curBtn.style.display === 'none' || !curBtn.classList.contains('cpf-shape--active')) {
      selectShape(autoShape);
    }
  }

  function selectShape(name) {
    var s = window.__cpfState;
    if (s) s.currentShape = name;

    document.querySelectorAll('#customPriceForm .cpf-shape').forEach(function (b) {
      b.classList.toggle('cpf-shape--active', b.dataset.shape === name);
    });

    calculate();
  }

  function getSacak() {
    var sel = $('cpfSacakSelect');
    if (sel) return sel.value === 'var';
    var c = document.querySelector('#customPriceForm input[name="cpf-sacak"]:checked');
    return c ? c.value === 'var' : false;
  }

  /* ============================================
    TAB SİSTEMİ
    ============================================ */
  function setNativeVisible(visible) {
    if (visible) {
      document.body.classList.remove('cpf-mode-ozel');
    } else {
      document.body.classList.add('cpf-mode-ozel');
    }
  }

  function switchTab(t) {
    if (window.__cpfState) window.__cpfState.activeTab = t;

    document.querySelectorAll('#customPriceForm .cpf-tab').forEach(function (b) {
      b.classList.remove('cpf-tab--active');
    });
    document.querySelectorAll('#customPriceForm .cpf-panel').forEach(function (p) {
      p.classList.remove('cpf-panel--active');
    });

    var tabBtn = document.querySelector('#customPriceForm [data-tab="' + t + '"]');
    var panel = $('cpf-panel-' + t);
    if (tabBtn) tabBtn.classList.add('cpf-tab--active');
    if (panel) panel.classList.add('cpf-panel--active');

    setNativeVisible(t === 'standart');

    var rating = document.querySelector('.nox-fake-rating-wrapper');
    if (rating) {
      if (t === 'ozel') {
        if (!rating._cpfOrigParent) {
          rating._cpfOrigParent = rating.parentNode;
          rating._cpfOrigNext = rating.nextSibling;
        }
        rating.style.cssText = 'float:none;position:static;display:block;margin:0 0 10px;text-align:left;';
        var enField = document.querySelector('#customPriceForm .cpf-fields');
        if (enField) enField.parentNode.insertBefore(rating, enField);
      } else {
        if (rating._cpfOrigParent) {
          rating.style.cssText = '';
          rating._cpfOrigParent.insertBefore(rating, rating._cpfOrigNext);
        }
      }
    }

    /* Özel tab'a dönünce hesaplamayı yenile — ölçüler varsa fiyat gösterilsin */
    if (t === 'ozel') calculate();
  }

  /* ============================================
    FORMU FİYATIN ALTINA TAŞI
    ============================================ */
  function repositionForm(retry) {
    var form = $('customPriceForm');
    if (!form) return;

    var section = form.closest('[id^="shopify-section"]') || form.closest('section');

    var selectors = [
      '.price:not(.price--tight)', '.price', '.product__price',
      '[data-product-price]', '.price--large', '.price-item--regular',
      '.kt-product-price', '.kt-price', '.kt-product-page-info .price'
    ];

    var priceEl = null;
    for (var i = 0; i < selectors.length; i++) {
      var candidates = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < candidates.length; j++) {
        var c = candidates[j];
        if (form.contains(c)) continue;
        if (c.closest && c.closest('sticky-add-to-cart')) continue;
        if (c.closest && c.closest('.sticky-add-to-cart__bar')) continue;
        if (c.closest && c.closest('.sticky-add-to-cart__price')) continue;
        if (c.closest && c.closest('.kt-sticky-atc')) continue;
        if (section && !section.contains(c)) continue;
        priceEl = c;
        break;
      }
      if (priceEl) break;
    }

    if (priceEl) {
      var target = priceEl;
      while (target.parentElement && target.parentElement.classList &&
        (target.parentElement.classList.contains('price') ||
          target.parentElement.classList.contains('kt-product-price'))) {
        target = target.parentElement;
      }
      if (form.previousElementSibling === target) return;
      target.parentNode.insertBefore(form, target.nextSibling);
      _dbg('Form fiyat altına taşındı');
    } else if (!retry || retry < 5) {
      setTimeout(function () { repositionForm((retry || 0) + 1); }, 300);
    }
  }

  /* ============================================
    [CUSTOM] VARYANTLARI GİZLE
    ============================================ */
  function hideCustomVariants() {
    var cpf = $('customPriceForm');

    document.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      if (cpf && cpf.contains(inp)) return;
      var val = (inp.value || '') + ' ' + (inp.getAttribute('data-option-value') || '');
      var _isCustom = val.indexOf('Özel Ölçü ') === 0 || val.indexOf(' Özel Ölçü ') > -1 || val.indexOf('Custom ') === 0 || val.indexOf(' Custom ') > -1;
      if (!_isCustom) return;
      inp.style.display = 'none';
      if (inp.id) {
        var lbl = document.querySelector('label[for="' + inp.id + '"]');
        if (lbl) lbl.style.display = 'none';
      }
      var wrapper = inp.closest('.kt-product-variant-value');
      if (wrapper) wrapper.style.display = 'none';
      var sib = inp.nextElementSibling;
      if (sib && sib.tagName === 'LABEL') sib.style.display = 'none';
      sib = inp.previousElementSibling;
      if (sib && sib.tagName === 'LABEL') sib.style.display = 'none';
    });

    document.querySelectorAll('label').forEach(function (lbl) {
      if (cpf && cpf.contains(lbl)) return;
      var _lblTxt = (lbl.textContent || '').trim();
      if (_lblTxt.indexOf('Özel Ölçü ') !== 0 && _lblTxt.indexOf('Custom ') !== 0) return;
      lbl.style.display = 'none';
      if (lbl.htmlFor) {
        var inp = $(lbl.htmlFor);
        if (inp) inp.style.display = 'none';
      }
    });

    document.querySelectorAll('select').forEach(function (sel) {
      if (cpf && cpf.contains(sel)) return;
      Array.from(sel.options).forEach(function (opt) {
        if ((opt.text || opt.value || '').indexOf('Özel Ölçü ') === 0 || (opt.text || opt.value || '').indexOf('Custom ') === 0) {
          opt.style.display = 'none';
          opt.disabled = true;
        }
      });
    });

    document.body.classList.add('cpf-variants-ready');
  }

  /* ============================================
    VARYANT PICKER OBSERVER
    ============================================ */
  function setupVarObserver() {
    if (window.__cpfVarObs) { try { window.__cpfVarObs.disconnect(); } catch (e) { } }

    window.__cpfVarObs = new MutationObserver(function () { hideCustomVariants(); });

    var targets = document.querySelectorAll(
      'variant-radios, variant-selects, product-variant-picker, ' +
      '.product-form__input, .variant-picker, .product-variant-picker, ' +
      '.kt-product-variants-picker, .kt-product-variant-value'
    );

    targets.forEach(function (el) {
      window.__cpfVarObs.observe(el, { childList: true, subtree: true, attributes: true });
    });

    if (targets.length === 0) {
      window.__cpfVarObs.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ============================================
    INPUT VALİDASYON
    ============================================ */
  function sanitize(inp) {
    var r = inp.value.replace(/[^0-9]/g, '');
    if (r !== inp.value) inp.value = r;
  }

  /* ============================================
    ORTAK VERİ HAZIRLAMA
    ============================================ */
  function getCalcData() {
    var s = window.__cpfState;
    if (!s || !s.calcData) return null;
    var noteIn = $('cpf-note');
    s.calcData.not = noteIn ? noteIn.value.trim() : '';
    return s.calcData;
  }

function buildProperties(d) {
  var s = window.__cpfState;
  var props = {};

  /* Kompakt boyut: 120x400 cm */
  props['Ölçü'] = d.girilenEn + 'x' + d.girilenBoy + ' cm';

  /* Gizli fatura verileri (underscore → sepette görünmez) */
  props['_Fatura En'] = d.faturaEn + ' cm';
  props['_Fatura Boy'] = d.faturaBoy + ' cm';
  props['_Alan'] = d.alan.toFixed(2) + ' m²';
  props['_Birim Fiyat'] = fmt(s ? s.m2Price : 0) + '/m²';
  props['_Hesaplanan Fiyat'] = fmt(d.fiyat);
  props['_Tip'] = d.tip === 'rulo' ? 'Rulo Kesim' : 'Jumbo Hazır Ebat';

  /* Saçak + Kesim tek satır */
  var detayParts = [];
  if (d.sacak !== '-') detayParts.push(d.sacak);
  if (d.kesim !== '-') detayParts.push(d.kesim);
  if (detayParts.length) props['Detay'] = detayParts.join(', ');

  if (d.not) props['Sipariş Notu'] = d.not;
  return props;
}

  /* ============================================
    LOADING OVERLAY — ikonu spinner içine taşı
    ============================================ */
  function mountOverlayIconInsideSpinner() {
    var overlay = $('cpfLoadingOverlay');
    if (!overlay) return;

    var spinner = overlay.querySelector('.cpf-loverlay__spinner');
    var icon = overlay.querySelector('.cpf-loverlay__icon');
    if (!spinner || !icon) return;
    if (spinner.contains(icon)) return;

    spinner.appendChild(icon);
  }

  /* ============================================
    SEPET DRAWER CSS — v3
    ============================================ */
  (function injectCartStyles() {
    var style = document.createElement('style');
    style.textContent = [

      '#site-cart-sidebar .kt-cart-item__actions {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 12px;',
      '  margin-top: 8px;',
      '}',

      /* Dış wrapper — kendi kenarlığı olmasın */
      '#site-cart-sidebar product-quantity,',
      '#site-cart-sidebar .kt-quantity-selector-holder {',
      '  border: none !important;',
      '  background: transparent !important;',
      '  padding: 0 !important;',
      '  display: inline-flex !important;',
      '}',

      /* İç container — kenarlıklı dikdörtgen kutu */
      '#site-cart-sidebar cart-product-quantity {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  gap: 0 !important;',
      '  background: #fff !important;',
      '  border: 1px solid #d0d0d0 !important;',
      '  border-radius: 4px !important;',
      '  padding: 0 !important;',
      '  overflow: hidden !important;',
      '}',

      /* Butonlar — container içinde transparan, kompakt */
      '#site-cart-sidebar .kt-qty-button {',
      '  width: 28px !important;',
      '  height: 28px !important;',
      '  min-width: 28px !important;',
      '  min-height: 28px !important;',
      '  border-radius: 0 !important;',
      '  background: transparent !important;',
      '  border: none !important;',
      '  cursor: pointer !important;',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  transition: background 0.15s !important;',
      '  flex-shrink: 0 !important;',
      '  padding: 0 !important;',
      '  color: #111 !important;',
      '}',

      '#site-cart-sidebar .kt-qty-button:hover {',
      '  background: #f5f5f5 !important;',
      '}',

      '#site-cart-sidebar .kt-qty-button svg {',
      '  width: 10px !important;',
      '  height: 10px !important;',
      '  pointer-events: none !important;',
      '}',

      /* Input — kenarlıksız, kompakt sayı */
      '#site-cart-sidebar .kt-qty,',
      '#site-cart-sidebar .kt-qty-selector {',
      '  width: 28px !important;',
      '  height: 28px !important;',
      '  text-align: center !important;',
      '  font-size: 12px !important;',
      '  font-weight: 400 !important;',
      '  border: none !important;',
      '  background: transparent !important;',
      '  -moz-appearance: textfield !important;',
      '  appearance: textfield !important;',
      '  outline: none !important;',
      '  color: #111 !important;',
      '  opacity: 1 !important;',
      '  visibility: visible !important;',
      '  display: inline-block !important;',
      '  padding: 0 !important;',
      '  line-height: 28px !important;',
      '}',

      '#site-cart-sidebar .kt-qty::-webkit-inner-spin-button,',
      '#site-cart-sidebar .kt-qty-selector::-webkit-inner-spin-button,',
      '#site-cart-sidebar .kt-qty::-webkit-outer-spin-button,',
      '#site-cart-sidebar .kt-qty-selector::-webkit-outer-spin-button {',
      '  -webkit-appearance: none !important;',
      '  margin: 0 !important;',
      '}',

      '#site-cart-sidebar .kt-remove {',
      '  font-size: 12px;',
      '  color: #999;',
      '  text-decoration: none;',
      '  transition: color 0.15s;',
      '  white-space: nowrap;',
      '}',

      '#site-cart-sidebar .kt-remove:hover {',
      '  color: #e53935;',
      '  text-decoration: underline;',
      '}',

      'body.cpf-overlay-open {',
      '  position: fixed !important;',
      '  width: 100% !important;',
      '  overflow-y: scroll !important;',
      '}',

      'body.kt-overlay-open #site-cart-sidebar,',
      'body.sidebar-open #site-cart-sidebar {',
      '  position: relative;',
      '  z-index: 1000001 !important;',
      '}',

      'body.kt-overlay-open #kt-site-overlay,',
      'body.kt-overlay-open .kt-site-overlay,',
      'body.sidebar-open #kt-site-overlay,',
      'body.sidebar-open .kt-site-overlay {',
      '  z-index: 1000000 !important;',
      '}',

      '#cpfLoadingOverlay {',
      '  pointer-events: all !important;',
      '}',

      '#cpfLoadingOverlay.cpf-loverlay--visible {',
      '  pointer-events: all !important;',
      '}',

      /* Loading overlay: sepet ikonunu dönen halkanın ortasına yerleştir */
      '#cpfLoadingOverlay .cpf-loverlay__spinner {',
      '  position: relative;',
      '}',
      '#cpfLoadingOverlay .cpf-loverlay__spinner > svg {',
      '  position: absolute;',
      '  top: 0;',
      '  left: 0;',
      '  width: 64px;',
      '  height: 64px;',
      '}',
      '#cpfLoadingOverlay .cpf-loverlay__spinner .cpf-loverlay__icon {',
      '  position: absolute;',
      '  top: 0;',
      '  left: 0;',
      '  width: 100%;',
      '  height: 100%;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  pointer-events: none;',
      '}',
      '#cpfLoadingOverlay .cpf-loverlay__spinner .cpf-loverlay__icon svg {',
      '  width: 24px;',
      '  height: 24px;',
      '}',

      /* ── Drawer: varyant ve property yazı boyutu büyüt ── */
      '#site-cart-sidebar .kt-cart-item__variant {',
      '  font-size: 13px !important;',
      '  opacity: 0.85 !important;',
      '}',

      '#site-cart-sidebar .kt-cart-item__property {',
      '  font-size: 13px !important;',
      '  opacity: 0.85 !important;',
      '}',

      '#site-cart-sidebar .kt-text-size--xsmall {',
      '  font-size: 13px !important;',
      '}',

      /* Property name (BOYUT:, DETAY: gibi bold kısımlar) */
      '#site-cart-sidebar .kt-cart-item__property-name {',
      '  font-size: 13px !important;',
      '  font-weight: 600 !important;',
      '}',

      '#site-cart-sidebar .kt-cart-item__property-value {',
      '  font-size: 13px !important;',
      '}',

      /* ── Safari select düzeltmesi ── */
      '.cpf-select {',
      '  -webkit-appearance: none !important;',
      '  -moz-appearance: none !important;',
      '  appearance: none !important;',
      '  height: 44px !important;',
      '  padding: 0 36px 0 12px !important;',
      '  box-sizing: border-box !important;',
      '  background-image: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\'%3E%3Cpath d=\'M1 1l5 5 5-5\' stroke=\'%23666\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E") !important;',
      '  background-repeat: no-repeat !important;',
      '  background-position: right 12px center !important;',
      '  background-color: #fff !important;',
      '  width: 100% !important;',
      '  font-size: 14px !important;',
      '  font-family: inherit !important;',
      '  border: 1px solid #ccc !important;',
      '  border-radius: 4px !important;',
      '  cursor: pointer !important;',
      '}'

    ].join('\n');

    document.head.appendChild(style);
  })();

  /* ============================================
    SEPET DRAWER — [CUSTOM] varyant adlarını gizle
    ============================================ */
  function hideCartCustomLabels() {
    try {
      document.querySelectorAll('.kt-cart-item__variant').forEach(function (el) {
        var _txt = (el.textContent || '').trim();
        if (_txt.indexOf('Özel Ölçü ') === 0 || _txt.indexOf('Custom ') === 0) {
          el.style.display = 'none';
        }
      });
    } catch (e) { _dbg('hideCartCustomLabels hata: ' + e.message); }
  }

  /* ============================================
    KALDIRMA SONRASI — sayaç + drawer güncelle
    ============================================ */
  function _cpfPostRemove(remainingCount) {
    var _cbDone = false;

    updateCartCount();
    refreshCartSection(function () {
      _cbDone = true;
      hideCartCustomLabels();

      if (remainingCount === 0) {
        /* ── Sepet boşaldı ──
           notifyThemeCart() ÇAĞIRILMAZ: tema boş sepet eventi alınca
           drawer'ı kendi yeniden açabilir → body kilidi geri gelir → donma.
           _forceUnlockPage() zaten refreshCartSection'ın dolu→boş dalında
           çağrıldı, ama güvenlik için tekrar çağır (idempotent). */
        _forceUnlockPage();
      } else {
        /* Sepette hâlâ ürün var — tema bilgilendirilmesi GECİKTİRİLİR.
           Hemen göndermek temanın kendi section re-render yapmasına →
           CPF güncellememizi ezmesine neden olur. */
        _cleanStuckOverlay();
        setTimeout(notifyThemeCart, 1500);
      }
    });

    /* GÜVENLİK AĞI: fetch takılırsa (mobil ağ) 5sn sonra zorla temizle */
    setTimeout(function () {
      if (_cbDone) return;
      _dbg('PostRemove güvenlik: callback gelmedi, zorla temizleniyor');
      hideCartCustomLabels();
      _forceUnlockPage();
    }, 5000);
  }

  /* Overlay takılı kaldıysa temizle — drawer kapalı AMA overlay görünür */
  function _cleanStuckOverlay() {
    var overlay = document.getElementById('kt-site-overlay') ||
      document.querySelector('.kt-site-overlay');
    if (!overlay) return;

    var sidebar = document.getElementById('site-cart-sidebar');
    var isDrawerOpen = sidebar && (
      sidebar.classList.contains('is-open') ||
      sidebar.classList.contains('kt-is-open') ||
      sidebar.getAttribute('aria-hidden') === 'false'
    );

    /* Drawer açıksa overlay doğru şekilde görünebilir — dokunma */
    if (isDrawerOpen) return;

    var cs = getComputedStyle(overlay);
    if (parseFloat(cs.opacity) > 0.05 || cs.visibility !== 'hidden') {
      _dbg('Takılı overlay tespit edildi, temizleniyor');
      overlay.classList.remove('is-visible', 'kt-is-visible', 'is-active', 'kt-is-active');
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
      document.body.classList.remove('kt-overlay-open', 'sidebar-open', 'kt-sidebar-open');
    }
  }

  /* ── Sayfayı zorla kilitsiz duruma getir ── */
  function _forceUnlockPage() {
    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar) {
      if (typeof sidebar.hide === 'function') {
        try { sidebar.hide(); } catch (e) { /* */ }
      }
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.classList.remove('is-open', 'kt-is-open');
    }
    document.body.classList.remove(
      'kt-overlay-open', 'sidebar-open', 'kt-sidebar-open',
      'kt-is-open', 'overflow-hidden'
    );
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    resetSiteOverlay();
    _dbg('Sayfa kilidi kaldırıldı (forceUnlock) ✓');
  }

  /* ============================================
    SEPET ÇEKMECE — Kaldır Link Delegation (v8)
    ============================================ */
  /* ─────────────────────────────────────────────────
     DÜZELTME v8 — Mobil donma (freeze) önleme:

     ÖNCEKİ SORUN (v7): Yalnızca 'click' capture dinleniyordu.
     Mobilde touch olayları click'ten ÖNCE tetiklenir:
       touchstart → touchend → (300ms) → click
     KT temasının kendi touchend handler'ı bizim click capture'dan
     önce çalışabilir → tema kendi AJAX remove'unu başlatır →
     overlay/body kilidi kalır → sayfa donar.

     ÇÖZÜM:
     1) touchend capture eklendi — mobilde tema handler'ından ÖNCE çalışır
     2) click capture — masaüstü + fallback (touchend zaten işlediyse yoksayar)
     3) AbortController ile 10sn zaman aşımı — mobil ağ takılması önlenir
     4) Hata durumunda da overlay temizliği yapılır
     ───────────────────────────────────────────────── */
  var _cpfRemoveBusy = false; /* aynı anda 2 kaldır isteği engeli */
  var _cpfTouchHandled = false; /* touchend zaten işledi, sentetik click'i yoksay */

  /* ── Hedef elementin sidebar içindeki kaldır linki olup olmadığını bul ── */
  function _cpfFindRemoveLink(target) {
    var sidebar = document.getElementById('site-cart-sidebar');
    if (!sidebar || !sidebar.contains(target)) return null;

    var a = target.closest('a[href*="/cart/change"], a[href*="cart/change"]');
    if (a) return a;

    var byData = target.closest('[data-cart-remove], [data-cart-item-remove], [data-remove-item]');
    if (byData) return byData;

    return target.closest('.kt-remove') || null;
  }

  /* ── Kaldır linkinden lineKey (kararlı) veya lineNum (pozisyonel) çıkar ── */
  function _cpfExtractLineId(removeLink) {
    var lineKey = null;
    var lineNum = null;
    var cartItem = removeLink.closest('[data-id]');
    if (cartItem) lineKey = cartItem.getAttribute('data-id');

    if (!lineKey) {
      lineKey = removeLink.getAttribute('data-line-key') ||
        removeLink.getAttribute('data-key') ||
        removeLink.getAttribute('data-cart-item-key');
    }

    if (!lineKey) {
      var dataHref = removeLink.getAttribute('data-href') || '';
      var realHref = removeLink.getAttribute('href') || '';
      var changeHref = dataHref.indexOf('/cart/change') > -1 ? dataHref
        : realHref.indexOf('/cart/change') > -1 ? realHref
          : '';
      var idMatch = changeHref.match(/[?&]id=([^&]+)/);
      if (idMatch) lineKey = decodeURIComponent(idMatch[1]);
    }

    if (!lineKey) {
      var dataHref2 = removeLink.getAttribute('data-href') || '';
      var realHref2 = removeLink.getAttribute('href') || '';
      var changeHref2 = dataHref2.indexOf('/cart/change') > -1 ? dataHref2
        : realHref2.indexOf('/cart/change') > -1 ? realHref2
          : '';
      var lineMatch = changeHref2.match(/[?&]line=([0-9]+)/);
      if (lineMatch) lineNum = parseInt(lineMatch[1]);

      if (!lineNum && cartItem) {
        var lineAttr = parseInt(cartItem.getAttribute('data-line') || '0', 10);
        if (lineAttr > 0) lineNum = lineAttr;
      }
    }

    return { key: lineKey, num: lineNum };
  }

  /* ── Kaldır AJAX işlemini gerçekleştir (touch + click ortak) ── */
  function _cpfExecuteRemove(removeLink) {
    if (_cpfRemoveBusy) {
      _dbg('Kaldır: zaten devam ediyor, yoksayılıyor');
      return;
    }
    _cpfRemoveBusy = true;

    var ids = _cpfExtractLineId(removeLink);
    if (!ids.key && !ids.num) {
      _dbg('Kaldır: tanımlayıcı bulunamadı!');
      _cpfRemoveBusy = false;
      return;
    }

    _dbg('Kaldır → key: ' + ids.key + ' line: ' + ids.num);

    removeLink.style.opacity = '0.4';
    removeLink.style.pointerEvents = 'none';

    var reqBody = ids.key
      ? { id: ids.key, quantity: 0 }
      : { line: ids.num, quantity: 0 };

    /* AbortController ile 10sn zaman aşımı — mobil ağ takılmasını önle */
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var abortTimer = controller
      ? setTimeout(function () { controller.abort(); }, 10000)
      : null;

    fetch(SHOPIFY_ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reqBody),
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/change.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        _dbg('Ürün kaldırıldı ✓ (kalan: ' + cart.item_count + ')');
        _cpfPostRemove(cart.item_count);
      })
      .catch(function (err) {
        _dbg('Kaldır hatası: ' + err.message);
        removeLink.style.opacity = '';
        removeLink.style.pointerEvents = '';
        /* Hata durumunda da overlay/body kilidini temizle */
        _cleanStuckOverlay();
      })
      .finally(function () {
        if (abortTimer) clearTimeout(abortTimer);
        setTimeout(function () { _cpfRemoveBusy = false; }, 600);
      });
  }

  /* ── Delegation kurulumu ── */
  (function delegateCartRemove() {

    if (window.__cpfRemoveDelegated) return;
    window.__cpfRemoveDelegated = true;

    /* ── Ortak event durdurma ── */
    function _stopEvent(e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }

    /* ── TOUCHSTART capture — temanın gesture/remove başlatmasını engelle ── */
    document.addEventListener('touchstart', function (e) {
      var removeLink = _cpfFindRemoveLink(e.target);
      if (!removeLink) return;
      /* Sadece propagation'ı durdur — tema touchstart'ta kendi
         AJAX remove'unu başlatmasın. preventDefault yok —
         touchend hâlâ tetiklensin. */
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }, { capture: true, passive: true });

    /* ── TOUCHEND capture — mobilde tema handler'larından ÖNCE çalışır ── */
    document.addEventListener('touchend', function (e) {
      var removeLink = _cpfFindRemoveLink(e.target);
      if (!removeLink) return;

      _stopEvent(e);

      /* Sonraki sentetik click'i yoksaymak için bayrak */
      _cpfTouchHandled = true;
      setTimeout(function () { _cpfTouchHandled = false; }, 800);

      _cpfExecuteRemove(removeLink);
    }, { capture: true, passive: false });

    /* ── CLICK capture — masaüstü + dokunmatik olmayan cihazlar ── */
    document.addEventListener('click', function (e) {
      var removeLink = _cpfFindRemoveLink(e.target);
      if (!removeLink) return;

      _stopEvent(e);

      /* touchend zaten işlediyse sentetik click'i yoksay */
      if (_cpfTouchHandled) {
        _dbg('Kaldır: touchend zaten işledi, click yoksayılıyor');
        return;
      }

      _cpfExecuteRemove(removeLink);
    }, true); /* ← CAPTURE PHASE */

    _dbg('Kaldır delegation kuruldu (capture + touch) ✓');
  })();

  /* ============================================
    SEPET SIDEBAR OBSERVER (debounce ile)
    ============================================ */
  var _cartObsTimer = null;
  function _debouncedHideCartLabels() {
    if (_cartObsTimer) clearTimeout(_cartObsTimer);
    _cartObsTimer = setTimeout(hideCartCustomLabels, 60);
  }

  (function setupCartObserver() {
    hideCartCustomLabels();

    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar) {
      new MutationObserver(_debouncedHideCartLabels)
        .observe(sidebar, { childList: true, subtree: true });
      _dbg('Cart sidebar observer kuruldu ✓');
    } else {
      var bodyObs = new MutationObserver(function () {
        var s = document.getElementById('site-cart-sidebar');
        if (s) {
          bodyObs.disconnect();
          new MutationObserver(_debouncedHideCartLabels)
            .observe(s, { childList: true, subtree: true });
          hideCartCustomLabels();
          _dbg('Cart sidebar observer kuruldu (gecikmeli) ✓');
        }
      });
      bodyObs.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  /* ============================================
    kt-site-overlay KORUYUCU OBSERVER
    ============================================ */
  (function setupOverlayGuard() {

    var _overlayHandler = null;

    function setupOverlayClick(overlay, sidebar) {
      if (_overlayHandler) {
        overlay.removeEventListener('click', _overlayHandler);
      }

      _overlayHandler = function (ev) {
        var target = ev && ev.target;
        if (!target) return;
        if (target !== overlay && !(target.closest && target.closest('#kt-site-overlay, .kt-site-overlay'))) return;

        var liveSidebar = document.getElementById('site-cart-sidebar') || sidebar;

        if (target.closest && target.closest('#site-cart-sidebar')) return;
        if (liveSidebar && liveSidebar.contains && liveSidebar.contains(target)) return;

        if (liveSidebar && typeof liveSidebar.hide === 'function') {
          liveSidebar.hide();
          _dbg('Overlay tıklandı → sidebar.hide() ✓');
        }
      };

      overlay.addEventListener('click', _overlayHandler);
      _dbg('Overlay click listener (yeniden) eklendi ✓');
    }

    function setupOverlayClickAfterOpen(sidebar, attempts) {
      attempts = attempts || 0;
      if (attempts > 10) {
        _dbg('Overlay bulunamadı, click listener eklenemedi');
        return;
      }

      var overlay = document.getElementById('kt-site-overlay') ||
        document.querySelector('.kt-site-overlay');

      if (overlay) {
        setupOverlayClick(overlay, sidebar);
      } else {
        setTimeout(function () {
          setupOverlayClickAfterOpen(sidebar, attempts + 1);
        }, 200);
      }
    }

    window.__cpfSetupOverlayClickAfterOpen = setupOverlayClickAfterOpen;

    function watchSidebar(sidebar) {
      setupOverlayClickAfterOpen(sidebar);

      new MutationObserver(function () {
        var isOpen = sidebar.classList.contains('is-open') ||
          sidebar.classList.contains('kt-is-open') ||
          sidebar.getAttribute('aria-hidden') === 'false';

        if (!isOpen) {
          /* ── FIX: cpf-mode-ozel geri ekle ──
             Drawer kapandığında, updateCartAndOpenDrawer'da kaldırılan
             cpf-mode-ozel class'ını geri ekle. */
          if (_cpfOzelSuspended) {
            _cpfOzelSuspended = false;
            /* activeTab hâlâ ozel ise class'ı geri ekle */
            if (window.__cpfState && window.__cpfState.activeTab === 'ozel') {
              document.body.classList.add('cpf-mode-ozel');
              _dbg('cpf-mode-ozel geri eklendi (drawer kapandı)');
            }
          }

          setTimeout(function () {
            /* ── FIX: Re-check — sidebar hâlâ kapalı mı? ──
               boş→dolu innerHTML copy sırasında class geçici olarak
               kaybolabilir → 350ms sonra sidebar tekrar açık olabilir */
            var stillClosed = !sidebar.classList.contains('is-open') &&
              !sidebar.classList.contains('kt-is-open') &&
              sidebar.getAttribute('aria-hidden') !== 'false';
            if (!stillClosed) return;

            var overlay = document.getElementById('kt-site-overlay') ||
              document.querySelector('.kt-site-overlay');
            if (!overlay) return;
            var cs = getComputedStyle(overlay);
            if (parseFloat(cs.opacity) > 0.1) {
              overlay.classList.remove('is-visible', 'kt-is-visible', 'is-active', 'kt-is-active');
              overlay.style.opacity = '0';
              overlay.style.visibility = 'hidden';
              document.body.classList.remove('kt-overlay-open', 'sidebar-open', 'kt-sidebar-open');
              _dbg('Overlay guard: kopuk overlay kapatıldı ✓');
            }
          }, 350);
        }
      }).observe(sidebar, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }

    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar) {
      watchSidebar(sidebar);
      _dbg('Overlay guard kuruldu ✓');
    } else {
      var obs = new MutationObserver(function () {
        var s = document.getElementById('site-cart-sidebar');
        if (s) {
          obs.disconnect();
          watchSidebar(s);
          _dbg('Overlay guard kuruldu (gecikmeli) ✓');
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  /* ============================================
    GLOBAL FREEZE WATCHDOG — Mobilde sayfa donmasını önle
    ============================================ */
  /* Drawer kapalı olmasına rağmen body kilidi veya overlay takılı
     kalabilir (tema race condition, ağ gecikmesi vb.). Her 2.5sn'de
     kontrol edip temizle. */
  (function setupFreezeWatchdog() {
    setInterval(function () {
      /* Grace period: drawer açılma sırasında watchdog MÜDAHALE ETME.
         Tema body class'ları ve is-open class'ını farklı frame'lerde
         ekleyebilir → aradaki boşlukta watchdog temizlik yaparsa
         drawer animasyonu bozulur. */
      if (Date.now() - _drawerOpenGrace < 4000) return;

      var sidebar = document.getElementById('site-cart-sidebar');
      var isDrawerOpen = sidebar && (
        sidebar.classList.contains('is-open') ||
        sidebar.classList.contains('kt-is-open') ||
        sidebar.getAttribute('aria-hidden') === 'false'
      );

      /* Drawer açıksa overlay/body doğru şekilde kilitli olabilir — dokunma */
      if (isDrawerOpen) return;

      /* Body kilidi kontrol */
      var bodyLocked = document.body.classList.contains('kt-overlay-open') ||
        document.body.classList.contains('sidebar-open') ||
        document.body.classList.contains('kt-sidebar-open');

      if (bodyLocked) {
        _dbg('Watchdog: drawer kapalı ama body kilitli → temizleniyor');
        document.body.classList.remove('kt-overlay-open', 'sidebar-open', 'kt-sidebar-open');
      }

      /* Overlay kontrol */
      _cleanStuckOverlay();
    }, 2500);

    _dbg('Freeze watchdog kuruldu ✓');
  })();

  /* ============================================
    LOADING OVERLAY — Adım yönetimi
    ============================================ */
  function showOverlay() {
    var el = $('cpfLoadingOverlay');
    if (!el) return;

    mountOverlayIconInsideSpinner();

    [1, 2, 3].forEach(function (i) {
      var s = $('cpfStep' + i);
      if (s) { s.classList.remove('cpf-loverlay__step--active', 'cpf-loverlay__step--done'); }
    });
    stepOverlay(1);
    el.style.pointerEvents = '';
    el.style.display = '';
    el.classList.add('cpf-loverlay--visible');
    el.setAttribute('aria-hidden', 'false');
    _overlayScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + _overlayScrollY + 'px';
    document.body.classList.add('cpf-overlay-open');
  }

  function stepOverlay(n) {
    [1, 2, 3].forEach(function (i) {
      var s = $('cpfStep' + i);
      if (!s) return;
      if (i < n) {
        s.classList.remove('cpf-loverlay__step--active');
        s.classList.add('cpf-loverlay__step--done');
      } else if (i === n) {
        s.classList.add('cpf-loverlay__step--active');
        s.classList.remove('cpf-loverlay__step--done');
      } else {
        s.classList.remove('cpf-loverlay__step--active', 'cpf-loverlay__step--done');
      }
    });
  }

  function hideOverlay() {
    var el = $('cpfLoadingOverlay');
    if (el) {
      el.classList.remove('cpf-loverlay--visible');
      el.setAttribute('aria-hidden', 'true');
      el.style.pointerEvents = 'none';
      el.style.display = 'none';
    }

    var scrollY = _overlayScrollY || (parseInt(document.body.style.top || '0', 10) * -1);
    document.body.classList.remove('cpf-overlay-open');
    document.body.style.top = '';
    if (scrollY) window.scrollTo(0, scrollY);
    _overlayScrollY = 0;

    setTimeout(function () { if (el) el.style.display = ''; }, 400);

    _dbg('Overlay kapatildi, scroll kilidi acildi');
  }

  function setBtnsLoading(on) {
    var cartBtn = $('cpfCartBtn');
    var orderBtn = $('cpfOrderBtn');
    var loadEl = $('cpfLoading');
    var errEl = $('cpfError');
    var toastEl = $('cpfToast');
    if (cartBtn) cartBtn.disabled = on;
    if (orderBtn) orderBtn.disabled = on;
    if (loadEl) loadEl.style.display = 'none';
    if (!on && errEl) errEl.style.display = 'none';
    if (toastEl && on) toastEl.style.display = 'none';
    if (on) { showOverlay(); } else { hideOverlay(); }
  }

  /* ============================================
    SEPETE EKLE — RETRY
    ============================================ */
  function addToCartRetry(vid, props, retriesLeft) {
    if (retriesLeft === ADD_TO_CART_RETRIES) stepOverlay(3);
    _dbg('cart/add.js deneniyor... kalan hak: ' + retriesLeft);

    /* sections parametresi: Shopify sectıon rendered HTML döner,
       tema bu response'ı intercept ederse drawer'ı kendisi günceller */
    var _cartAddBody = { items: [{ id: vid, quantity: 1, properties: props }] };
    if (_cachedCartSectionId) {
      _cartAddBody.sections = _cachedCartSectionId;
      _cartAddBody.sections_url = window.location.pathname;
    }

    return fetch(SHOPIFY_ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(_cartAddBody)
    }).then(function (r) {
      if (r.ok) {
        _dbg('cart/add.js başarılı ✓');
        return r;
      }

      if (r.status === 422 && retriesLeft > 0) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          _dbg('422 alındı (' + (body.description || body.message || '') +
            '), ' + retriesLeft + ' hak kaldı, ' + (ADD_TO_CART_RETRY_DELAY_MS / 1000) + 's bekleniyor...');
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              addToCartRetry(vid, props, retriesLeft - 1)
                .then(resolve)
                .catch(reject);
            }, ADD_TO_CART_RETRY_DELAY_MS);
          });
        });
      }

      _dbg('cart/add.js kalıcı hata: ' + r.status);
      return r;
    });
  }

  /* ============================================
    YARDIMCI FONKSİYONLAR (cart doğrulama)
    ============================================ */
  function parseJsonSafe(response) {
    return response.json().catch(function () { return {}; });
  }

  function fetchCartJson() {
    return fetch(SHOPIFY_ROOT + 'cart.js?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js başarısız (' + r.status + ')');
        return r.json();
      });
  }

  function isCartLineHealthy(line) {
    if (!line) return false;
    var unitPrice = Number(line.final_price != null ? line.final_price : line.price);
    var lineTotal = Number(
      line.final_line_price != null ? line.final_line_price :
        (line.line_price != null ? line.line_price :
          (line.final_price != null ? line.final_price : line.price))
    );
    return isFinite(unitPrice) && unitPrice > 0 && isFinite(lineTotal) && lineTotal > 0;
  }

  function findCartLine(cart, lineKey, variantId) {
    var items = (cart && cart.items) ? cart.items : [];
    var i;

    if (lineKey) {
      for (i = 0; i < items.length; i++) {
        if (items[i] && items[i].key === lineKey) return items[i];
      }
    }

    for (i = 0; i < items.length; i++) {
      if (items[i] && String(items[i].variant_id) === String(variantId)) return items[i];
    }

    return null;
  }

  function removeLineByKey(lineKey) {
    if (!lineKey) return Promise.resolve();

    return fetch(SHOPIFY_ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/change.js başarısız (' + r.status + ')');
      return parseJsonSafe(r);
    });
  }

  function ensureAddedLineHealthy(variantId, lineKey) {
    return fetchCartJson().then(function (cart) {
      var line = findCartLine(cart, lineKey, variantId);
      if (!line) return { ok: false, reason: 'line-not-found', line: null };
      if (isCartLineHealthy(line)) return { ok: true, reason: 'ok', line: line };
      return { ok: false, reason: 'zero-price', line: line };
    });
  }

  function addVariantToCartGuaranteed(variantId, props, maxAttempts) {
    var attempt = 0;

    function runOnce() {
      attempt += 1;
      _dbg('Garantili sepet denemesi ' + attempt + '/' + maxAttempts);

      return addToCartRetry(variantId, props, ADD_TO_CART_RETRIES)
        .then(function (r) {
          if (!r.ok) {
            return parseJsonSafe(r).then(function (errData) {
              throw new Error(errData.description || errData.message || ('Sepete eklenemedi (' + r.status + ')'));
            });
          }
          return parseJsonSafe(r);
        })
        .then(function (addData) {
          /* Sections response'u kaydet — updateCartAndOpenDrawer kullanacak */
          if (addData && addData.sections) {
            _lastCartAddSections = addData.sections;
            _dbg('Sections response kaydedildi ✓');
          }
          var addedItem = addData && addData.items && addData.items[0] ? addData.items[0] : null;
          var lineKey = addedItem ? addedItem.key : null;

          return new Promise(function (resolve) { setTimeout(resolve, 400); })
            .then(function () { return ensureAddedLineHealthy(variantId, lineKey); })
            .then(function (check) {
              if (check.ok) return check;

              _dbg('Sepet doğrulama başarısız: ' + check.reason + '. Satır temizlenip tekrar denenecek.');

              return removeLineByKey(lineKey).catch(function (cleanErr) {
                _dbg('Bozuk satır temizleme hatası: ' + cleanErr.message);
              }).then(function () {
                if (attempt >= maxAttempts) {
                  throw new Error('Shopify senkronu gecikti. Lütfen tekrar deneyin.');
                }

                var retryWaitMs = 1200 * attempt;
                return new Promise(function (resolve) { setTimeout(resolve, retryWaitMs); })
                  .then(runOnce);
              });
            });
        });
    }

    return runOnce();
  }

  /* ============================================
    TEMA'YA CART REFRESH SİNYALİ GÖNDER
    ============================================ */
  function notifyThemeCart() {
    var eventNames = [
      'cart:updated',
      'cart:change'
    ];

    eventNames.forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: { id: 'site-cart-sidebar', source: 'cpf' }
        }));
        window.dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: { id: 'site-cart-sidebar', source: 'cpf' }
        }));
      } catch (e) { }
    });

    _dbg('Tema cart event\'leri gönderildi ✓');
  }

  /* ============================================
    CART SECTION GÜNCELLE
    ============================================ */
  function refreshCartSection(onDone) {
    var cartSectionId = null;
    var cartSectionEl = null;

    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar) {
      /* Yöntem 1: doğrudan ancestor section wrapper */
      var sectionWrapper = sidebar.closest('[id^="shopify-section-"]');
      if (sectionWrapper) {
        cartSectionId = sectionWrapper.id.replace('shopify-section-', '');
        cartSectionEl = sectionWrapper;
        _cachedCartSectionId = cartSectionId;
      }

      /* Yöntem 2: tüm section wrapper'ları tara (sidebar farklı seviyede olabilir) */
      if (!cartSectionId) {
        var allSections = document.querySelectorAll('[id^="shopify-section-"]');
        for (var _sIdx = 0; _sIdx < allSections.length; _sIdx++) {
          if (allSections[_sIdx].querySelector('#site-cart-sidebar')) {
            cartSectionId = allSections[_sIdx].id.replace('shopify-section-', '');
            cartSectionEl = allSections[_sIdx];
            _cachedCartSectionId = cartSectionId;
            break;
          }
        }
      }

      /* Yöntem 3: önceki başarılı section ID (cache) */
      if (!cartSectionId && _cachedCartSectionId) {
        cartSectionId = _cachedCartSectionId;
      }
    }

    if (cartSectionId) {
      _dbg('Sections API ile cart güncelleniyor: ' + cartSectionId);
      fetch(SHOPIFY_ROOT + '?sections=' + cartSectionId + '&_=' + Date.now(), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[cartSectionId];
          if (!html) { if (onDone) onDone(); return; }

          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newSidebar = tmp.querySelector('#site-cart-sidebar');
          var oldSidebar = document.getElementById('site-cart-sidebar');

          if (!newSidebar || !oldSidebar) { if (onDone) onDone(); return; }

          /* ── BOŞ ↔ DOLU GEÇİŞ TESPİTİ ── */
          var oldItemCount = parseInt(oldSidebar.getAttribute('data-cart-items') || '0', 10);
          var newItemCount = parseInt(newSidebar.getAttribute('data-cart-items') || '0', 10);

          if ((oldItemCount > 0 && newItemCount === 0) || (oldItemCount === 0 && newItemCount > 0)) {
            var direction = oldItemCount === 0 ? 'boş→dolu' : 'dolu→boş';
            _dbg('Sepet ' + direction + ' geçişi, tüm sidebar innerHTML değiştiriliyor');
            oldSidebar.innerHTML = newSidebar.innerHTML;

            /* newSidebar'dan attribute'ları kopyala.
               aria-hidden ve style KOPYALANMAZ: "canlı durum" attribute'ları,
               server HTML'i drawer'ın açık/kapalı olduğunu bilmez.

               class attr: yöne göre farklı davranış:
               - boş→dolu: KOPYALA. Tema CSS "empty vs has-items" durumunu
                 sidebar class'ı ile kontrol eder. Kopyalanmazsa tema
                 ürünleri gizler, boş sepet mesajı gösterir.
                 Güvenli çünkü drawer şu an kapalı (is-open yok).
               - dolu→boş: KOPYALAMA. is-open/kt-is-open korunmalı,
                 _forceUnlockPage() graceful close yapacak. */
            Array.prototype.slice.call(newSidebar.attributes).forEach(function (attr) {
              if (attr.name === 'aria-hidden' || attr.name === 'style') return;
              if (attr.name === 'class' && newItemCount === 0) return; /* dolu→boş: class koru */
              oldSidebar.setAttribute(attr.name, attr.value);
            });

            /* innerHTML değiştirince close button listener'ı gider — yeniden bağla */
            var closeBtn = oldSidebar.querySelector('.kt-sidebar__close, [data-close-sidebar], .cart-drawer__close, [aria-label="Close"]');
            if (closeBtn) {
              closeBtn.addEventListener('click', function (ev) {
                ev.preventDefault();
                _forceUnlockPage();
                _dbg('Sidebar kapatıldı (re-bind close) ✓');
              });
              _dbg('Close button listener yeniden bağlandı ✓');
            }

            /* Dolu→boş geçişi: HEMEN kapat, bekleme YOK.
               600ms gecikme temanın araya girip body kilidini geri
               eklemesine fırsat veriyordu → mobil donma. */
            if (newItemCount === 0) {
              _forceUnlockPage();
              _dbg('Dolu→boş: drawer kapatıldı, overlay temizlendi ✓');
            }

            _dbg(direction + ' geçişi tamamlandı ✓');
            hideCartCustomLabels();
            if (onDone) onDone();
            return;
          }

          /* ── HER ZAMAN TAM innerHTML DEĞİŞTİR ──
             Eski partial update (selector tabanlı) KT temasının HTML yapısını
             bulamıyordu → footer/toplam güncellenemiyordu.
             Şimdi tüm durumlarda tam innerHTML değişimi yapılıyor,
             drawer'ın açık/kapalı durumu korunuyor. */

          /* Drawer açık durumunu KAYDET */
          var _wasOpen = oldSidebar.classList.contains('is-open') ||
            oldSidebar.classList.contains('kt-is-open') ||
            oldSidebar.getAttribute('aria-hidden') === 'false';
          var _savedClasses = oldSidebar.className;
          var _savedAriaHidden = oldSidebar.getAttribute('aria-hidden');
          var _savedStyle = oldSidebar.getAttribute('style');

          /* Tam innerHTML değiştir */
          oldSidebar.innerHTML = newSidebar.innerHTML;
          _dbg('Cart drawer tam innerHTML güncellendi ✓');

          /* Attribute'ları kopyala (aria-hidden, style, class HARİÇ) */
          Array.prototype.slice.call(newSidebar.attributes).forEach(function (attr) {
            if (attr.name === 'aria-hidden' || attr.name === 'style' || attr.name === 'class') return;
            oldSidebar.setAttribute(attr.name, attr.value);
          });

          /* Drawer açık durumunu GERİ YAZ */
          if (_wasOpen) {
            oldSidebar.className = _savedClasses;
            if (_savedAriaHidden !== null) {
              oldSidebar.setAttribute('aria-hidden', _savedAriaHidden);
            }
            if (_savedStyle !== null) {
              oldSidebar.setAttribute('style', _savedStyle);
            }
          } else {
            /* data-cart-items attribute'ını güncelle */
            var newCount = newSidebar.getAttribute('data-cart-items');
            if (newCount !== null) {
              oldSidebar.setAttribute('data-cart-items', newCount);
            }
          }

          /* Close button listener'ı yeniden bağla */
          var closeBtn = oldSidebar.querySelector('.kt-sidebar__close, [data-close-sidebar], .cart-drawer__close, [aria-label="Close"]');
          if (closeBtn) {
            closeBtn.addEventListener('click', function (ev) {
              ev.preventDefault();
              _forceUnlockPage();
              _dbg('Sidebar kapatıldı (re-bind close) ✓');
            });
          }

          _dbg('Cart drawer HTML güncellendi ✓');
          hideCartCustomLabels();
          if (onDone) onDone();
        })
        .catch(function (err) {
          _dbg('Sections API hata: ' + err.message + ' — fallback');
          _fallbackRefresh(onDone);
        });
      return;
    }

    /* Section ID hiç bulunamadı — yaygın section ID'ler ile probe dene */
    _probeCartSections(sidebar, onDone);
  }

  /* Sections API probe: yaygın cart section ID'lerini toplu olarak dene */
  function _probeCartSections(sidebar, onDone) {
    if (!sidebar) { if (onDone) onDone(); return; }

    var candidateIds = [
      'cart-drawer', 'kt-cart-drawer', 'mini-cart', 'cart-sidebar',
      'sidebar-cart', 'kt-sidebar-cart', 'ajax-cart', 'drawer-cart'
    ];
    _dbg('Section ID bulunamadı, probe: ' + candidateIds.join(','));

    fetch(SHOPIFY_ROOT + '?sections=' + candidateIds.join(',') + '&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        for (var ci = 0; ci < candidateIds.length; ci++) {
          var html = data[candidateIds[ci]];
          if (html && html.indexOf('site-cart-sidebar') > -1) {
            _cachedCartSectionId = candidateIds[ci];
            _dbg('Section ID probe ile bulundu: ' + candidateIds[ci]);
            /* refreshCartSection yeniden çağır — artık cache mevcut */
            refreshCartSection(onDone);
            return;
          }
        }
        _dbg('Probe sonuç bulamadı — tema notify denenecek');
        _fallbackNotifyTheme(onDone);
      })
      .catch(function (err) {
        _dbg('Probe hata: ' + err.message);
        _fallbackNotifyTheme(onDone);
      });
  }

  /* Son çare: temanın kendi güncelleme mekanizmasını tetikle */
  function _fallbackNotifyTheme(onDone) {
    notifyThemeCart();
    setTimeout(function () {
      hideCartCustomLabels();
      if (onDone) onDone();
    }, 600);
  }

  function _fallbackRefresh(onDone) {
    _fallbackNotifyTheme(onDone);
  }

  /* ============================================
    CART DRAWER AÇICI
    ============================================ */
  function openCartDrawer() {
    var sidebar = document.getElementById('site-cart-sidebar');

    /* Drawer zaten açıksa tekrar açmaya gerek yok — sadece içerik yenile */
    if (sidebar) {
      var _alreadyOpen = sidebar.classList.contains('is-open') ||
        sidebar.classList.contains('kt-is-open') ||
        sidebar.getAttribute('aria-hidden') === 'false';
      if (_alreadyOpen) {
        _dbg('Drawer zaten açık, sadece içerik yenileniyor (forceFullSync)');
        refreshCartSection(function () { hideCartCustomLabels(); }, { forceFullSync: true });
        if (window.__cpfSetupOverlayClickAfterOpen) {
          window.__cpfSetupOverlayClickAfterOpen(sidebar);
        }
        return;
      }
    }

    _drawerOpenGrace = Date.now();

    if (sidebar && typeof sidebar.show === 'function') {
      sidebar.show();
      _dbg('Cart drawer açıldı (yöntem 1: sidebar.show()) ✓');
      if (window.__cpfSetupOverlayClickAfterOpen) {
        window.__cpfSetupOverlayClickAfterOpen(sidebar);
      }
      return;
    }

    if (window.KT && window.KT.sidebarCart && typeof window.KT.sidebarCart.open === 'function') {
      window.KT.sidebarCart.open();
      _dbg('Cart drawer açıldı (yöntem 2: KT.sidebarCart.open()) ✓');
      if (sidebar && window.__cpfSetupOverlayClickAfterOpen) {
        window.__cpfSetupOverlayClickAfterOpen(sidebar);
      }
      return;
    }

    var opened = false;
    ['sidebar:open', 'cart:open', 'drawer:open'].forEach(function (evtName) {
      if (opened) return;
      try {
        document.dispatchEvent(new CustomEvent(evtName, {
          detail: { id: 'site-cart-sidebar' }, bubbles: true
        }));
        var s = document.getElementById('site-cart-sidebar');
        if (s && (s.classList.contains('is-open') || s.classList.contains('kt-is-open') ||
          s.getAttribute('aria-hidden') === 'false' || s.hasAttribute('open'))) {
          opened = true;
          _dbg('Cart drawer açıldı (yöntem 3: CustomEvent ' + evtName + ') ✓');
          if (window.__cpfSetupOverlayClickAfterOpen) {
            window.__cpfSetupOverlayClickAfterOpen(s);
          }
        }
      } catch (e) { }
    });
    if (opened) return;

    var cartTriggers = [
      '[data-open-sidebar="site-cart-sidebar"]',
      '[href="#site-cart-sidebar"]',
      '[data-cart-toggle]',
      '[data-js-cart-toggle]',
      '.kt-cart-icon',
      '[data-sidebar-toggle]',
      'a[href="/cart"].kt-header__icon',
      '.site-header__cart'
    ];
    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger) {
        trigger.click();
        _dbg('Cart drawer açıldı (yöntem 4: trigger.click() → ' + cartTriggers[i] + ') ✓');
        if (sidebar && window.__cpfSetupOverlayClickAfterOpen) {
          setTimeout(function () {
            window.__cpfSetupOverlayClickAfterOpen(sidebar);
          }, 300);
        }
        return;
      }
    }

    if (sidebar) {
      sidebar.setAttribute('aria-hidden', 'false');
      sidebar.classList.add('is-open', 'kt-is-open');
      document.body.classList.add('kt-overlay-open', 'sidebar-open');
      var overlay = document.querySelector('.kt-overlay, .site-overlay, [data-overlay]');
      if (overlay) overlay.classList.add('is-active', 'kt-is-active');
      _dbg('Cart drawer açıldı (yöntem 5: manuel CSS toggle) ✓');
      if (window.__cpfSetupOverlayClickAfterOpen) {
        window.__cpfSetupOverlayClickAfterOpen(sidebar);
      }
      return;
    }

    _dbg('Cart drawer açılamadı — hiçbir yöntem çalışmadı!');
  }

  /* ============================================
    SEPET SAYACINI GÜNCELLE
    ============================================ */
  function updateCartCount() {
    fetch(SHOPIFY_ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          '.cart-count-bubble span, [data-cart-count], .header__cart-count, ' +
          '[data-header-cart-count], .kt-cart-count, [data-js-cart-count]'
        ).forEach(function (b) { b.textContent = cart.item_count; });
        _dbg('Sepet sayacı güncellendi: ' + cart.item_count);
      })
      .catch(function () { });
  }

  /* ============================================
    kt-site-overlay SIFIRLA
    ============================================ */
  function resetSiteOverlay() {
    var overlay = document.getElementById('kt-site-overlay');
    if (!overlay) {
      overlay = document.querySelector('.kt-site-overlay');
    }
    if (!overlay) return;

    overlay.classList.remove('is-visible', 'kt-is-visible', 'is-active', 'kt-is-active');
    overlay.style.opacity = '';
    overlay.style.pointerEvents = '';
    overlay.style.visibility = '';

    document.body.classList.remove('kt-overlay-open', 'sidebar-open', 'kt-sidebar-open');

    _dbg('kt-site-overlay sıfırlandı ✓');
  }

  /* ============================================
    CART DRAWER GÜNCELLE VE AÇ
    ============================================ */
  /* ============================================
    DRAWER TOPLAM FİYAT DÜZELTME
    notifyThemeCart → tema re-render → toplam fiyat eski kalıyor.
    cart.js'den gerçek toplamı alıp drawer footer'ı elle güncelle.
    ============================================ */
  function fixCartDrawerTotal() {
    fetchCartJson().then(function (cart) {
      var sidebar = document.getElementById('site-cart-sidebar');
      if (!sidebar) return;

      var totalCents = cart.total_price; /* Shopify kuruş cinsinden döner */
      var totalVal = totalCents / 100;
      var totalStr = fmt(totalVal);

      _dbg('fixCartDrawerTotal: cart.js total = ' + totalStr);

      /* Toplam metin alanları */
      var totalSelectors = [
        '.kt-cart__subtotal', '.kt-cart__total-value',
        '.kt-cart-form__total', '[data-cart-total]',
        '.cart-total__price', '.cart-drawer__total-price'
      ];

      /* Walker: sidebar içindeki fiyat text node'larını tara,
         "Toplam" label'ının EN YAKIN kardeş span/strong'undaki fiyatı güncelle.
         Vergi/KDV satırlarına DOKUNMA. */
      var allEls = sidebar.querySelectorAll('*');
      for (var i = 0; i < allEls.length; i++) {
        var el = allEls[i];
        var txt = (el.textContent || '').trim();

        /* "Toplam" label'ının yanındaki fiyat */
        if (txt === 'Toplam' || txt === 'TOPLAM' || txt === 'Subtotal') {
          var parent = el.parentElement;
          if (parent) {
            /* Kardeş veya parent içindeki money/fiyat span'ını bul */
            var priceEls = parent.querySelectorAll('span, strong, .money, [data-cart-total]');
            var _toplamUpdated = false;
            for (var j = 0; j < priceEls.length; j++) {
              if (_toplamUpdated) break; /* Sadece ilk eşleşeni güncelle */
              var pTxt = (priceEls[j].textContent || '').trim();
              if (/[\d.,]+\s*TL/i.test(pTxt) && priceEls[j] !== el) {
                /* Vergi / KDV / Tax satırını ATLAMA */
                var _pParentTxt = (priceEls[j].closest('p, div, li, tr, dt, dd') || priceEls[j].parentElement || {}).textContent || '';
                if (/vergi|kdv|tax|vat|dahil/i.test(_pParentTxt)) continue;
                priceEls[j].textContent = totalStr;
                _toplamUpdated = true;
                _dbg('fixCartDrawerTotal: Toplam güncellendi → ' + totalStr);
              }
            }
          }
        }
      }

      /* Checkout butonu — sadece EN DERİN span'ı güncelle */
      var checkoutBtn = sidebar.querySelector('#CheckOut') ||
        sidebar.querySelector('[name="checkout"]') ||
        sidebar.querySelector('button[type="submit"]');

      if (checkoutBtn) {
        /* En derin (leaf) span'ı bul — KT teması iç içe span kullanır */
        var allSpans = checkoutBtn.querySelectorAll('span');
        var targetSpan = null;

        /* Fiyat içeren en derin span'ı bul */
        for (var si = allSpans.length - 1; si >= 0; si--) {
          var sp = allSpans[si];
          /* Kendi içinde başka span OLMAYAN ve fiyat içeren span */
          if (sp.querySelectorAll('span').length === 0 && /[\d.,]+\s*TL/i.test(sp.textContent)) {
            targetSpan = sp;
            break;
          }
        }

        if (targetSpan) {
          targetSpan.textContent = targetSpan.textContent.replace(
            /[\d.,]+(\s*TL)/i,
            function(m, suffix) {
              return totalVal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
            }
          );
          _dbg('fixCartDrawerTotal: Checkout butonu güncellendi (leaf span) → ' + targetSpan.textContent);
        } else if (/[\d.,]+\s*TL/i.test(checkoutBtn.textContent)) {
          /* Span yoksa direkt buton metnini güncelle */
          checkoutBtn.childNodes.forEach(function(node) {
            if (node.nodeType === 3 && /[\d.,]+\s*TL/i.test(node.textContent)) {
              node.textContent = node.textContent.replace(
                /[\d.,]+(\s*TL)/i,
                function(m, suffix) {
                  return totalVal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
                }
              );
            }
          });
        }
      }

      /* Bilinen class selector'lar ile de dene.
         Container element ise textNode seviyesinde güncelle → vergi satırının
         DOM yapısı korunur. */
      totalSelectors.forEach(function (sel) {
        var el = sidebar.querySelector(sel);
        if (!el) return;
        /* Vergi/KDV içeren container'ları atla */
        var elFullText = (el.textContent || '').toLowerCase();
        if (/vergi|kdv|tax|vat|dahil/i.test(elFullText) && el.children.length > 0) return;

        if (el.children.length === 0 && /[\d.,]+\s*TL/i.test(el.textContent)) {
          /* Leaf element — güvenle textContent güncelle */
          el.textContent = el.textContent.replace(
            /[\d.,]+(\s*TL)/i, function (m, suffix) {
              return totalVal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
            }
          );
        } else if (el.children.length > 0) {
          /* Container — child text node'ları tek tek güncelle, DOM yapısı korunsun */
          for (var ni = 0; ni < el.childNodes.length; ni++) {
            var cNode = el.childNodes[ni];
            if (cNode.nodeType === 3 && /[\d.,]+\s*TL/i.test(cNode.textContent)) {
              cNode.textContent = cNode.textContent.replace(
                /[\d.,]+(\s*TL)/i, function (m, suffix) {
                  return totalVal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
                }
              );
            }
          }
        }
      });
    }).catch(function (err) {
      _dbg('fixCartDrawerTotal hata: ' + err.message);
    });
  }

  function updateCartAndOpenDrawer() {
    _drawerOpenGrace = Date.now();

    // cpf-mode-ozel geçici kaldır (overlay açıkken flash olmaz)
    if (document.body.classList.contains('cpf-mode-ozel')) {
      document.body.classList.remove('cpf-mode-ozel');
      _cpfOzelSuspended = true;
      _dbg('cpf-mode-ozel geçici kaldırıldı (drawer açılacak)');
    }

    _lastCartAddSections = null;

    // Tema'nın kendi cart sidebar'ını sections API ile güncelle
    refreshCartSection(function () {
      hideCartCustomLabels();
      _openDrawerViaThemeForm();
      setTimeout(fixCartDrawerTotal, 1500);
      setTimeout(fixCartDrawerTotal, 3500);
      setTimeout(fixCartDrawerTotal, 6000);
    });
  }

  function _openDrawerViaThemeForm() {
    // Yöntem 1: KT tema'nın sidebar show metodu (en güvenilir)
    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar && typeof sidebar.show === 'function') {
      sidebar.show();
      _dbg('Drawer açıldı: sidebar.show() ✓');
      if (window.__cpfSetupOverlayClickAfterOpen) {
        window.__cpfSetupOverlayClickAfterOpen(sidebar);
      }
      return;
    }

    // Yöntem 2: KT tema API
    if (window.KT && window.KT.sidebarCart) {
      if (typeof window.KT.sidebarCart.open === 'function') {
        window.KT.sidebarCart.open();
        _dbg('Drawer açıldı: KT.sidebarCart.open() ✓');
        return;
      }
    }

    // Yöntem 3: Tema formuna dummy varyant yazıp submit event tetikle
    // (tema bu event'i intercept edip drawer açar)
    var themeForm = document.getElementById(
      'product-form-template--18558246715458__main-7632553050178'
    ) || document.querySelector('form.kt-form-add-to-cart[action="/cart/add"]');

    if (themeForm) {
      var submitBtn = themeForm.querySelector(
        '[data-js-product-add-to-cart]'
      ) || themeForm.querySelector('[data-main-product-add-to-cart]');

      if (submitBtn && !submitBtn.disabled) {
        // Buton zaten aktif — sadece drawer açılış event'lerini gönder
        _dbg('Tema formu bulundu, drawer event\'leri gönderiliyor...');
      }
    }

    // Yöntem 4: KT'nin drawer açma event sistemi
    var eventsToTry = [
      'sidebar:open',
      'kt:cart:open',
      'cart:open',
      'theme:cart:open'
    ];

    var opened = false;
    eventsToTry.forEach(function(evtName) {
      if (opened) return;
      try {
        document.dispatchEvent(new CustomEvent(evtName, {
          bubbles: true,
          detail: { id: 'site-cart-sidebar', source: 'cpf' }
        }));
        window.dispatchEvent(new CustomEvent(evtName, {
          bubbles: true,
          detail: { id: 'site-cart-sidebar', source: 'cpf' }
        }));
      } catch(e) {}
    });

    // Yöntem 5: KT cart trigger butonunu tıkla
    setTimeout(function() {
      var sidebar2 = document.getElementById('site-cart-sidebar');
      var isOpen = sidebar2 && (
        sidebar2.classList.contains('is-open') ||
        sidebar2.classList.contains('kt-is-open') ||
        sidebar2.getAttribute('aria-hidden') === 'false'
      );

      if (!isOpen) {
        var cartTriggers = [
          '[data-open-sidebar="site-cart-sidebar"]',
          '[href="#site-cart-sidebar"]',
          '.kt-cart-icon',
          '[data-js-cart-toggle]',
          '[data-cart-toggle]',
          'a[href="/cart"].kt-header__icon',
          '.site-header__cart'
        ];

        for (var i = 0; i < cartTriggers.length; i++) {
          var trigger = document.querySelector(cartTriggers[i]);
          if (trigger) {
            trigger.click();
            _dbg('Drawer açıldı: trigger.click() → ' + cartTriggers[i] + ' ✓');
            if (window.__cpfSetupOverlayClickAfterOpen) {
              setTimeout(function() {
                window.__cpfSetupOverlayClickAfterOpen(
                  document.getElementById('site-cart-sidebar')
                );
              }, 300);
            }
            return;
          }
        }

        // Son çare: manuel CSS toggle
        if (sidebar2) {
          sidebar2.setAttribute('aria-hidden', 'false');
          sidebar2.classList.add('is-open', 'kt-is-open');
          document.body.classList.add('kt-overlay-open', 'sidebar-open');
          _dbg('Drawer açıldı: manuel CSS toggle ✓');
        }
      } else {
        _dbg('Drawer zaten açık ✓');
      }

      if (window.__cpfSetupOverlayClickAfterOpen) {
        window.__cpfSetupOverlayClickAfterOpen(
          document.getElementById('site-cart-sidebar')
        );
      }
    }, 400);
  }

  /* Tema'nın kendi cart trigger butonunu simüle ederek drawer aç.
     Bu, standart "Sepete Ekle" butonuyla aynı akışı tetikler →
     tema kendi section fetch'ini yapar, footer/butonları doğru render eder. */
  function _openCartDrawerViaThemeTrigger() {
    /* Yöntem 1: KT tema API */
    if (window.KT && window.KT.sidebarCart && typeof window.KT.sidebarCart.open === 'function') {
      window.KT.sidebarCart.open();
      _dbg('Drawer açıldı (KT.sidebarCart.open) ✓');
      return;
    }

    /* Yöntem 2: sidebar.show() (custom element) */
    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar && typeof sidebar.show === 'function') {
      sidebar.show();
      _dbg('Drawer açıldı (sidebar.show) ✓');
      return;
    }

    /* Yöntem 3: Tema cart trigger butonunu tıkla */
    var cartTriggers = [
      '[data-open-sidebar="site-cart-sidebar"]',
      '[href="#site-cart-sidebar"]',
      '[data-cart-toggle]',
      '[data-js-cart-toggle]',
      '.kt-cart-icon',
      'a[href="/cart"].kt-header__icon'
    ];
    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger) {
        trigger.click();
        _dbg('Drawer açıldı (trigger: ' + cartTriggers[i] + ') ✓');
        return;
      }
    }

    /* Yöntem 4: Custom event */
    ['sidebar:open', 'cart:open'].forEach(function (evtName) {
      document.dispatchEvent(new CustomEvent(evtName, {
        detail: { id: 'site-cart-sidebar' }, bubbles: true
      }));
    });
    _dbg('Drawer açılma event\'leri gönderildi');
  }

  /* ============================================
    SEPETE EKLE ANA FONKSİYON (eski, yedek)
    ============================================ */
  function handleCartClick() {
    var s = window.__cpfState;
    var d = getCalcData();

    if (!d || !s) {
      _dbg('handleCartClick: calcData yok, çıkılıyor');
      return;
    }

    setBtnsLoading(true);
    _dbg('Varyant oluşturuluyor...');

    /* Sepet boş mu? Eklemeden önce kaydet */
    fetch(SHOPIFY_ROOT + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { _cartItemCountBefore = c.item_count || 0; })
      .catch(function () { _cartItemCountBefore = -1; });

    fetch(CART_VARIANT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: s.productId,
        shopDomain: s.shopDomain,
        girilenEn: d.girilenEn,
        girilenBoy: d.girilenBoy,
        faturaEn: d.faturaEn,
        faturaBoy: d.faturaBoy,
        price: d.fiyat,
        comparePrice: d.eskiFiyat || null,
        tip: d.tip,
        kesim: d.kesim,
        sacak: d.sacak
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Varyant API hatası: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data.success || !data.variantId) {
          throw new Error(data.error || 'Varyant oluşturulamadı');
        }
        _dbg('Varyant hazır: ' + data.variantId + ' — Shopify sync için ' + (VARIANT_SYNC_WAIT_MS / 1000) + 's bekleniyor...');
        stepOverlay(2);

        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(addToCartRetry(data.variantId, buildProperties(d), ADD_TO_CART_RETRIES));
          }, VARIANT_SYNC_WAIT_MS);
        });
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (errData) {
            throw new Error(errData.description || errData.message || ('Sepete eklenemedi (' + r.status + ')'));
          }, function () {
            throw new Error('Sepete eklenemedi (' + r.status + ')');
          });
        }
        return r.json();
      })
      .then(function (cartData) {
        _dbg('Sepete eklendi ✓');

        var addedItem = cartData && cartData.items && cartData.items[0];
        if (addedItem && addedItem.price === 0) {
          _dbg('0.00TL tespit edildi — ürün siliniyor, tekrar eklenecek...');
          var lineKey = addedItem.key;
          fetch(SHOPIFY_ROOT + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          }).then(function (changeRes) {
            if (!changeRes.ok) {
              throw new Error('0.00TL fix: cart/change.js başarısız (' + changeRes.status + ')');
            }
            return new Promise(function (resolve) { setTimeout(resolve, 2000); });
          }).then(function () {
            var d2 = getCalcData();
            var s2 = window.__cpfState;
            if (!d2 || !s2) {
              throw new Error('0.00TL fix: hesap verisi bulunamadı');
            }
            var _reAddBody = { items: [{ id: addedItem.variant_id, quantity: 1, properties: buildProperties(d2) }] };
            if (_cachedCartSectionId) {
              _reAddBody.sections = _cachedCartSectionId;
              _reAddBody.sections_url = window.location.pathname;
            }
            return fetch(SHOPIFY_ROOT + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(_reAddBody)
            });
          }).then(function (reAddRes) {
            if (!reAddRes || !reAddRes.ok) {
              throw new Error('0.00TL fix: cart/add.js başarısız (' + (reAddRes ? reAddRes.status : 'no-response') + ')');
            }
            return reAddRes.json().catch(function () { return {}; });
          }).then(function () {
            _dbg('0.00TL fix: yeniden eklendi ✓');
            setBtnsLoading(false);
            updateCartCount();
            setTimeout(function () { updateCartAndOpenDrawer(); }, 300);
          }).catch(function (fixErr) {
            _dbg('0.00TL fix başarısız: ' + fixErr.message);
            setBtnsLoading(false);
            updateCartCount();
            setTimeout(function () { updateCartAndOpenDrawer(); }, 300);
          });
          return;
        }

        setBtnsLoading(false);
        updateCartCount();
        setTimeout(function () { updateCartAndOpenDrawer(); }, 300);
      })
      .catch(function (err) {
        _dbg('Hata: ' + err.message);
        var el = $('cpfError');
        if (el) {
          el.textContent = 'Hata: ' + err.message;
          el.style.display = 'block';
        }
        var cartBtn = $('cpfCartBtn');
        var orderBtn = $('cpfOrderBtn');
        var loadEl = $('cpfLoading');
        if (cartBtn) cartBtn.disabled = false;
        if (orderBtn) orderBtn.disabled = false;
        if (loadEl) loadEl.style.display = 'none';
        hideOverlay();
      });
  }

  /* ============================================
    SEPETE EKLE — GÜVENİLİR AKIŞ (v8 — race condition fix)
    ============================================ */
  function handleCartClickReliable() {
    var s = window.__cpfState;
    var d = getCalcData();

    if (!d || !s) {
      _dbg('handleCartClick: calcData yok, çıkılıyor');
      return;
    }

    if (_cartFlowBusy) {
      _dbg('Sepet akışı zaten çalışıyor, tekrar tık engellendi');
      return;
    }

    _cartFlowBusy = true;
    setBtnsLoading(true);
    _dbg('Sepet kontrol ediliyor...');

    var propsSnapshot = buildProperties(d);

    /*
     * FIX v8: cart.js fetch artık promise zincirine dahil.
     * Önceki davranış: fetch beklenmiyor → _cartItemCountBefore hep -1 kalıyordu
     *                  → sepet boşken reload tetiklenmiyordu → drawer açılmıyordu
     * Yeni davranış:   cart.js bittikten SONRA varyant oluşturma başlıyor
     */
    fetch(SHOPIFY_ROOT + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        _cartItemCountBefore = c.item_count || 0;
        _dbg('Sepet önceki ürün sayısı: ' + _cartItemCountBefore);
      })
      .catch(function () {
        _cartItemCountBefore = -1;
        _dbg('cart.js okunamadı, _cartItemCountBefore = -1');
      })
      .then(function () {
        _dbg('Varyant oluşturuluyor (reliable akış)...');

        return fetch(CART_VARIANT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: s.productId,
            shopDomain: s.shopDomain,
            girilenEn: d.girilenEn,
            girilenBoy: d.girilenBoy,
            faturaEn: d.faturaEn,
            faturaBoy: d.faturaBoy,
            price: d.fiyat,
            comparePrice: d.eskiFiyat || null,
            tip: d.tip,
            kesim: d.kesim,
            sacak: d.sacak
          })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Varyant API hatası: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data.success || !data.variantId) {
          throw new Error(data.error || 'Varyant oluşturulamadı');
        }

        _dbg('Varyant hazır: ' + data.variantId + ' — Shopify sync için ' + (VARIANT_SYNC_WAIT_MS / 1000) + 's bekleniyor...');
        stepOverlay(2);

        return new Promise(function (resolve) {
          setTimeout(function () { resolve(data.variantId); }, VARIANT_SYNC_WAIT_MS);
        });
      })
      .then(function (variantId) {
        return addVariantToCartGuaranteed(variantId, propsSnapshot, 4);
      })
      .then(function () {
        _dbg('Sepete eklendi ve doğrulandı ✓');
        _cartFlowBusy = false;
        updateCartCount();
        /* Önce drawer güncelle+aç, SONRA overlay'i kapat.
           Overlay açıkken cpf-mode-ozel kaldırılır → native element flashı önlenir. */
        setTimeout(function() {
          updateCartAndOpenDrawer();
        }, 200);
        /* Drawer açıldıktan sonra butonları sıfırla + overlay kapat */
        setTimeout(function () { setBtnsLoading(false); }, 250);
      })
      .catch(function (err) {
        _dbg('Hata: ' + err.message);
        var el = $('cpfError');
        if (el) {
          el.textContent = 'Hata: ' + err.message;
          el.style.display = 'block';
        }
        var cartBtn = $('cpfCartBtn');
        var orderBtn = $('cpfOrderBtn');
        var loadEl = $('cpfLoading');
        if (cartBtn) cartBtn.disabled = false;
        if (orderBtn) orderBtn.disabled = false;
        if (loadEl) loadEl.style.display = 'none';
        _cartFlowBusy = false;
        hideOverlay();
      });
  }

  /* ============================================
    HEMEN SATIN AL (cpfOrderBtn)
    — Native Shopify checkout akışı (Online Store kanalı)
    — Sepeti geçici temizle → varyant ekle → /checkout yönlendir
    — Geri dönüşte eski sepeti geri yükle
    ============================================ */
  var _savedCartForBuyNow = null;

  function _restoreSavedCart() {
    var saved = _savedCartForBuyNow;
    if (!saved) return Promise.resolve();
    _savedCartForBuyNow = null;

    return fetch(SHOPIFY_ROOT + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }).then(function () {
      if (!saved.items || !saved.items.length) return;
      var items = saved.items.map(function (item) {
        return { id: item.variant_id, quantity: item.quantity, properties: item.properties || {} };
      });
      return fetch(SHOPIFY_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function () {
      if (saved.note) {
        return fetch(SHOPIFY_ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: saved.note })
        });
      }
    }).catch(function (err) {
      _dbg('Sepet geri yükleme hatası: ' + err.message);
    });
  }

  function handleOrderClick() {
    var s = window.__cpfState;
    var d = getCalcData();
    if (!d || !s) return;

    setBtnsLoading(true);
    showOverlay(); stepOverlay(1);

    /* 1) Backend'de varyant oluştur (create-cart-variant) */
    fetch(CART_VARIANT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: s.productId,
        shopDomain: s.shopDomain,
        girilenEn: d.girilenEn,
        girilenBoy: d.girilenBoy,
        faturaEn: d.faturaEn,
        faturaBoy: d.faturaBoy,
        price: d.fiyat,
        comparePrice: d.eskiFiyat || null,
        tip: d.tip,
        kesim: d.kesim,
        sacak: d.sacak
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Varyant API hatası: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data.success || !data.variantId) {
          throw new Error(data.error || 'Varyant oluşturulamadı');
        }
        _dbg('Hemen Al: varyant hazır: ' + data.variantId);
        stepOverlay(2);

        /* 2) Mevcut sepeti kaydet */
        return fetch(SHOPIFY_ROOT + 'cart.js', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.item_count > 0) {
              _savedCartForBuyNow = cart;
              try { sessionStorage.setItem('__cpf_saved_cart', JSON.stringify(cart)); } catch (e) {}
            }
            return data.variantId;
          })
          .catch(function () { return data.variantId; });
      })
      .then(function (variantId) {
        /* 3) Shopify sync bekle */
        return new Promise(function (resolve) {
          setTimeout(function () { resolve(variantId); }, VARIANT_SYNC_WAIT_MS);
        });
      })
      .then(function (variantId) {
        /* 4) Sepeti temizle */
        return fetch(SHOPIFY_ROOT + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        }).then(function () { return variantId; });
      })
      .then(function (variantId) {
        stepOverlay(3);
        var props = buildProperties(d);

        /* 5) Varyantı sepete ekle (retry ile) */
        return addToCartRetry(variantId, props, ADD_TO_CART_RETRIES)
          .then(function (r) {
            if (!r.ok) throw new Error('Sepete eklenemedi (' + r.status + ')');
            return r.json();
          });
      })
      .then(function () {
        /* 6) Sepet notunu ayarla */
        var tipLabel = d.tip === 'jumbo' ? 'Jumbo Hazır Ebat' : 'Rulo Kesim';
        var noteLines = [
          'Özel Ölçü Siparişi',
          'Ürün: ' + (s.productTitle || '-'),
          'Müşteri Girişi: ' + d.girilenEn + ' x ' + d.girilenBoy + ' cm',
          'Fatura Ölçüsü: ' + d.faturaEn + ' x ' + d.faturaBoy + ' cm',
          'Tip: ' + tipLabel,
          'Kesim: ' + (d.kesim || '-'),
          'Saçak: ' + (d.sacak || '-')
        ];
        if (d.not) noteLines.push('Müşteri Notu: ' + d.not);

        return fetch(SHOPIFY_ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteLines.join('\n') })
        });
      })
      .then(function () {
        /* 7) Checkout'a yönlendir → Online Store kanalı */
        _dbg('Hemen Al: checkout yönlendirme ✓');
        window.location.href = SHOPIFY_ROOT + 'checkout';
      })
      .catch(function (err) {
        _dbg('Hemen Al HATA: ' + err.message);
        /* Hata durumunda sepeti geri yükle */
        _restoreSavedCart().then(function () {
          hideOverlay();
          var el = $('cpfError');
          if (el) { el.textContent = 'Hata: ' + err.message; el.style.display = 'block'; }
          setBtnsLoading(false);
        });
      });
  }

  /* ============================================
    EVENT DELEGATION
    ============================================ */

  document.addEventListener('click', function (e) {
    var t = e.target;

    var tabBtn = t.closest('#customPriceForm .cpf-tab');
    if (tabBtn && tabBtn.dataset.tab) {
      switchTab(tabBtn.dataset.tab);
      return;
    }

    var shapeBtn = t.closest('#customPriceForm .cpf-shape');
    if (shapeBtn && !shapeBtn.disabled) {
      selectShape(shapeBtn.dataset.shape);
      return;
    }

    var sacakOpt = t.closest('#customPriceForm .cpf-sacak-opt');
    if (sacakOpt) {
      document.querySelectorAll('#customPriceForm .cpf-sacak-opt').forEach(function (l) {
        l.classList.remove('cpf-sacak-opt--active');
      });
      sacakOpt.classList.add('cpf-sacak-opt--active');
      var radio = sacakOpt.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      calculate();
      return;
    }

    if (t.closest('#cpfCartBtn')) {
      handleCartClickReliable();
      return;
    }

    if (t.closest('#cpfOrderBtn')) {
      handleOrderClick();
      return;
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'cpf-en' || t.id === 'cpf-boy') {
      sanitize(t);
      calculate();
    }
  });

  document.addEventListener('paste', function (e) {
    var t = e.target;
    if (t.id === 'cpf-en' || t.id === 'cpf-boy') {
      setTimeout(function () { sanitize(t); calculate(); }, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t.id === 'cpf-en' || t.id === 'cpf-boy') {
      if (e.ctrlKey || e.metaKey) return;
      if (['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End']
        .indexOf(e.key) > -1) return;
      if (e.key && e.key.length === 1 && !/[0-9]/.test(e.key)) e.preventDefault();
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.id === 'cpfSacakSelect') {
      calculate();
    }
  });

  /* ============================================
    VARYANT DEĞİŞİNCE → FORMU YENİDEN BAŞLAT
    ============================================ */
  var _origPush = history.pushState;
  var _origReplace = history.replaceState;
  var _lastHref = location.href;

  function checkReload() {
    if (location.href === _lastHref) return;
    _lastHref = location.href;
    if (!$('customPriceForm')) return;

    var activeTab = document.querySelector('#customPriceForm .cpf-tab--active');
    if (activeTab && activeTab.getAttribute('data-tab') === 'standart') {
      try {
        var urlVid = new URLSearchParams(location.search).get('variant');
        if (urlVid) {
          var W = $('customPriceForm');
          if (W) W.setAttribute('data-variant-id', urlVid);
          if (window.__cpfState) window.__cpfState.variantId = urlVid;
        }
      } catch (e) { }
      hideCustomVariants();
      return;
    }

    _dbg('Variant değişti → form yeniden başlatılıyor');
    try {
      var urlVid2 = new URLSearchParams(location.search).get('variant');
      if (urlVid2) {
        var W2 = $('customPriceForm');
        if (W2) W2.setAttribute('data-variant-id', urlVid2);
      }
    } catch (e) { }
    initCPF(true);
    hideCustomVariants();
  }

  history.pushState = function () {
    _origPush.apply(this, arguments);
    checkReload();
  };
  history.replaceState = function () {
    _origReplace.apply(this, arguments);
    checkReload();
  };

  window.addEventListener('pageshow', function (e) {
    _cartFlowBusy = false;
    var overlay = $('cpfLoadingOverlay');
    if (overlay && overlay.classList.contains('cpf-loverlay--visible')) {
      hideOverlay();
      _dbg('pageshow: overlay kapatıldı (checkout geri dönüşü) ✓');
    }
  });

  window.addEventListener('popstate', function () {
    _cartFlowBusy = false;
    var overlay = $('cpfLoadingOverlay');
    if (overlay && overlay.classList.contains('cpf-loverlay--visible')) {
      hideOverlay();
    }
    checkReload();
  });

  setInterval(function () {
    hideCustomVariants();
    hideCartCustomLabels();
    fixSearchPrices();
  }, 1500);

  /* ============================================
    ARAMA / KOLEKSİYON: CUSTOM VARYANT FİYATINI DÜZELT
    Shopify price_min hesabına custom varyantlar dahil oluyor.
    Örn: Ürün 23.660TL ama 500TL'lik custom varyant varsa
    arama sonuçlarında "500TL'DAN SATIŞTA" gözüküyor.
    Çözüm: Ürün JSON'ını çekip custom olmayan varyantların
    en düşük fiyatını bulup fiyat metnini güncelle.
    ============================================ */
  var _fixedProductCache = {}; /* handle → { minPrice, minCompare } */
  var _fixInProgress = {};     /* handle → true (aynı anda 2x fetch engeli) */

  function fixSearchPrices() {
    /* Sayfadaki tüm ürün kartlarını/linklerini tara */
    var links = document.querySelectorAll('a[href*="/products/"]');
    if (links.length === 0) return;

    /* Handle bazlı grupla: her handle için TÜM linklerini topla */
    var handleMap = {}; /* handle → [link, link, …] */
    links.forEach(function (link) {
      var m = (link.href || '').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var handle = m[1];
      if (!handleMap[handle]) handleMap[handle] = [];
      handleMap[handle].push(link);
    });

    Object.keys(handleMap).forEach(function (handle) {
      var handleLinks = handleMap[handle];

      /* Cache hit — TÜM linkleri kontrol et */
      if (handle in _fixedProductCache) {
        if (_fixedProductCache[handle]) {
          handleLinks.forEach(function (l) {
            var pe = findPriceEl(l);
            if (pe && pe.dataset.cpfFixed !== handle) {
              applyFixedPrice(pe, _fixedProductCache[handle], handle);
            }
          });
        }
        return;
      }

      /* Fetch et */
      if (_fixInProgress[handle]) return;
      _fixInProgress[handle] = true;

      fetch('/products/' + handle + '.json')
        .then(function (r) {
          if (!r.ok) {
            /* 404 veya diğer HTTP hatalarında sonsuz retry engelle */
            _fixedProductCache[handle] = null;
            return null;
          }
          return r.json();
        })
        .then(function (data) {
          if (!data) return;
          var product = data.product;
          if (!product || !product.variants) return;

          /* Custom olmayan varyantları filtrele */
          var stdVariants = product.variants.filter(function (v) {
            var t = (v.title || '') + ' ' + (v.option1 || '');
            return t.indexOf('Özel Ölçü') === -1
              && t.indexOf('Custom ') === -1
              && t.indexOf('[CUSTOM]') === -1;
          });

          if (stdVariants.length === 0) {
            _fixedProductCache[handle] = null;
            return;
          }

          /* En düşük standart fiyat */
          var minPrice = Infinity;
          var minCompare = 0;
          stdVariants.forEach(function (v) {
            var p = parseFloat(v.price);
            if (p < minPrice) {
              minPrice = p;
              minCompare = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
            }
          });

          /* Tüm varyantların min fiyatı */
          var currentMin = Infinity;
          product.variants.forEach(function (v) {
            var p = parseFloat(v.price);
            if (p < currentMin) currentMin = p;
          });

          /* Eğer genel min === standart min ise düzeltmeye gerek yok */
          if (Math.abs(currentMin - minPrice) < 0.01) {
            _fixedProductCache[handle] = null;
            return;
          }

          _dbg('fixSearchPrices: ' + handle + ' yanlış=' + fmt(currentMin) + ' doğru=' + fmt(minPrice));
          var result = { minPrice: minPrice, minCompare: minCompare };
          _fixedProductCache[handle] = result;

          /* Tüm linklerdeki fiyatları güncelle */
          document.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (l) {
            var pe = findPriceEl(l);
            if (pe && pe.dataset.cpfFixed !== handle) {
              applyFixedPrice(pe, result, handle);
            }
          });
        })
        .catch(function (e) { _dbg('fixSearchPrices fetch hata: ' + handle + ' ' + e.message); })
        .finally(function () { delete _fixInProgress[handle]; });
    });
  }

  /* Link'ten fiyat elementini bul — yukarı veya yandaki kartta arar */
  function findPriceEl(link) {
    /* Strateji 1: link'in parent kartında ara */
    var card = link.closest(
      '.product-card, .card-wrapper, .card--product, .kt-product-card, ' +
      '.predictive-search__result-group li, .predictive-search__list-item, ' +
      '.search-results li, .collection-product-card, article, .grid__item, ' +
      '.kt-product-item, .kt-collection-product, li'
    );
    if (card) {
      var el = card.querySelector(
        '.kt-product-price--regular, .kt-product-price, .kt-product-card__price, ' +
        '.price, [data-product-price], .product-price, .kt-price, .price__container'
      );
      if (el) return el;
    }

    /* Strateji 2: link'in kardeş elementlerinde ara */
    var parent = link.parentElement;
    if (parent) {
      var el2 = parent.querySelector(
        '.kt-product-price--regular, .kt-product-price, .kt-product-card__price, ' +
        '.price, [data-product-price], .product-price, .kt-price'
      );
      if (el2) return el2;

      /* Bir üst seviye daha */
      var grandpa = parent.parentElement;
      if (grandpa) {
        var el3 = grandpa.querySelector(
          '.kt-product-price--regular, .kt-product-price, .kt-product-card__price, ' +
          '.price, [data-product-price], .product-price, .kt-price'
        );
        if (el3) return el3;
      }
    }

    /* Strateji 3: link'in içinde ara */
    var el4 = link.querySelector(
      '.kt-product-price--regular, .kt-product-price, .kt-product-card__price, ' +
      '.price, [data-product-price], .product-price, .kt-price'
    );
    return el4 || null;
  }

  /* Bir element ağacı içindeki ilk fiyat text node'unu güncelle.
     DOM yapısını bozmaz → tema CSS'i ve font stili korunur. */
  function _replacePrice(el, newVal) {
    var raw = newVal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var nd;
    while ((nd = walker.nextNode())) {
      if (/[\d.,]+\s*TL/i.test(nd.textContent)) {
        nd.textContent = nd.textContent.replace(/[\d.,]+(\s*TL)/i, raw + '$1');
        return true;
      }
    }
    return false;
  }

  function applyFixedPrice(priceEl, data, handle) {
    if (!data) return; /* null = düzeltme gerekmez */
    priceEl.dataset.cpfFixed = handle;

    var newPriceText = fmt(data.minPrice);

    /* ─── KT tema: DOM yapısını KORUYARAK sadece fiyat rakamını değiştir ─── */
    var hiddenSpan = priceEl.querySelector('.kt-visually-hidden');
    if (hiddenSpan) {
      /* Mevcut text node'daki fiyat sayısını güncelle — innerHTML KULLANMA.
         Böylece tema formatı ("Satış fiyatı: X TL" / "X TL'dan satışta" vb.)
         aynen korunur, font boyutu/kalınlığı değişmez, flash olmaz. */
      if (!_replacePrice(priceEl, data.minPrice)) {
        /* Fallback: text node bulunamadı — innerHTML ile yaz */
        var rawPrice = data.minPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        priceEl.innerHTML = '<span class="kt-visually-hidden">Fiyat:</span>' + rawPrice + 'TL';
      }

      /* Kardeş compare/karşılaştırma fiyat elementini güncelle */
      var parent = priceEl.parentElement;
      if (parent && data.minCompare > data.minPrice) {
        var cmpEl = parent.querySelector(
          '.kt-product-price--compare, [class*="price--compare"], ' +
          '.kt-product-price--sale, [class*="price--sale"]'
        );
        if (cmpEl) {
          _replacePrice(cmpEl, data.minCompare);
          cmpEl.style.display = '';
        }
      }

      _dbg('fixSearchPrices: ' + handle + ' → ' + newPriceText);
      return;
    }

    /* Shopify Dawn/standart: <span class="price-item--regular">X TL</span> */
    var regularSpan = priceEl.querySelector(
      '.price-item--regular, .price-item--sale, .product-price__price, .kt-product-price__price, .money'
    );
    if (regularSpan) {
      regularSpan.textContent = newPriceText;
      var salePrefix = priceEl.querySelector('.price-item--sale-prefix, .price__from');
      if (salePrefix) salePrefix.style.display = 'none';
      var compareSpan = priceEl.querySelector('.price-item--compare, .price-item--regular[aria-hidden]');
      if (compareSpan) {
        if (data.minCompare > data.minPrice) {
          compareSpan.textContent = fmt(data.minCompare);
          compareSpan.style.display = '';
        } else {
          compareSpan.style.display = 'none';
        }
      }
      _dbg('fixSearchPrices: ' + handle + ' → ' + newPriceText);
      return;
    }

    /* Fallback: düz metin değiştir */
    var txt = priceEl.textContent || '';
    if (/[\d.,]+\s*(?:TL|₺)/i.test(txt)) {
      priceEl.textContent = newPriceText;
      _dbg('fixSearchPrices(fallback): ' + handle + ' → ' + newPriceText);
    }
  }

  /* Predictive search açıldığında da çalış */
  var _searchObserver = new MutationObserver(function () {
    setTimeout(fixSearchPrices, 80);
    setTimeout(fixSearchPrices, 300);
    setTimeout(fixSearchPrices, 600);
  });

  /* KT temasının olası search container'larını bul ve observe et */
  var _searchSelectors = [
    'predictive-search', '.predictive-search', '#predictive-search',
    '.kt-search-form', '.kt-search', '#site-search',
    'search-modal', '.search-modal', '.kt-search-results',
    '#shopify-section-kt-search', '.kt-sidebar--search',
    '[data-search-results]', '.search-results-wrapper'
  ];
  _searchSelectors.forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) _searchObserver.observe(el, { childList: true, subtree: true });
  });

  /* Search input'larına input event listener ekle */
  function _bindSearchInputs() {
    document.querySelectorAll(
      'input[type="search"], input[name="q"], input[data-search-input], ' +
      '.kt-search__input, .search-modal__input, .predictive-search__input'
    ).forEach(function (inp) {
      if (inp._cpfBound) return;
      inp._cpfBound = true;
      inp.addEventListener('input', function () {
        setTimeout(fixSearchPrices, 200);
        setTimeout(fixSearchPrices, 500);
        setTimeout(fixSearchPrices, 1000);
      });
    });
  }
  _bindSearchInputs();
  setTimeout(_bindSearchInputs, 2000);

  /* Body observer — predictive-search dinamik oluşursa */
  new MutationObserver(function (mutations) {
    var shouldFix = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        var tag = (n.tagName || '').toLowerCase();
        var cls = n.classList || { contains: function () { return false; } };
        if (tag === 'predictive-search' || tag === 'search-modal' ||
          cls.contains('predictive-search') || cls.contains('kt-search') ||
          cls.contains('search-modal') || cls.contains('kt-search-results') ||
          cls.contains('kt-sidebar--search')) {
          _searchObserver.observe(n, { childList: true, subtree: true });
          shouldFix = true;
        }
        /* Arama sonuçları içinde fiyat veya link varsa da kontrol et */
        if (n.querySelector && (
          n.querySelector('a[href*="/products/"]') ||
          n.querySelector('.kt-product-price--regular') ||
          n.querySelector('[data-product-price]')
        )) {
          shouldFix = true;
        }
        /* Search input yeni eklendiyse bind et */
        if (n.querySelector && n.querySelector('input[type="search"], input[name="q"]')) {
          _bindSearchInputs();
        }
      });
    });
    if (shouldFix) {
      setTimeout(fixSearchPrices, 80);
      setTimeout(fixSearchPrices, 400);
      setTimeout(fixSearchPrices, 800);
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* ============================================
    İLK BAŞLATMA
    ============================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCPF(); });
  } else {
    setTimeout(initCPF, 50);
  }

  _dbg('Script yüklendi ✓');

})();
